(() => {
function $5725b2021a85accb$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $5725b2021a85accb$export$7c398597f8905a1(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $5725b2021a85accb$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $5725b2021a85accb$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}


/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $512d98b1c01b30c5$var$t = globalThis, $512d98b1c01b30c5$export$b4d10f6001c083c2 = $512d98b1c01b30c5$var$t.ShadowRoot && (void 0 === $512d98b1c01b30c5$var$t.ShadyCSS || $512d98b1c01b30c5$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $512d98b1c01b30c5$var$s = Symbol(), $512d98b1c01b30c5$var$o = new WeakMap;
class $512d98b1c01b30c5$export$505d1e8739bad805 {
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if ($512d98b1c01b30c5$export$b4d10f6001c083c2 && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = $512d98b1c01b30c5$var$o.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && $512d98b1c01b30c5$var$o.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
    constructor(t, e, o){
        if (this._$cssResult$ = !0, o !== $512d98b1c01b30c5$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
}
const $512d98b1c01b30c5$export$8d80f9cac07cdb3 = (t)=>new $512d98b1c01b30c5$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $512d98b1c01b30c5$var$s), $512d98b1c01b30c5$export$dbf350e5966cf602 = (t, ...e)=>{
    const o = 1 === t.length ? t[0] : e.reduce((e, s, o)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[o + 1], t[0]);
    return new $512d98b1c01b30c5$export$505d1e8739bad805(o, t, $512d98b1c01b30c5$var$s);
}, $512d98b1c01b30c5$export$2ca4a66ec4cecb90 = (s, o)=>{
    if ($512d98b1c01b30c5$export$b4d10f6001c083c2) s.adoptedStyleSheets = o.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet);
    else for (const e of o){
        const o = document.createElement("style"), n = $512d98b1c01b30c5$var$t.litNonce;
        void 0 !== n && o.setAttribute("nonce", n), o.textContent = e.cssText, s.appendChild(o);
    }
}, $512d98b1c01b30c5$export$ee69dfd951e24778 = $512d98b1c01b30c5$export$b4d10f6001c083c2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return $512d98b1c01b30c5$export$8d80f9cac07cdb3(e);
    })(t) : t;


var $fa6dcceba7c06772$var$_Symbol, $fa6dcceba7c06772$var$_a, $fa6dcceba7c06772$var$_a1;
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { is: $fa6dcceba7c06772$var$i, defineProperty: $fa6dcceba7c06772$var$e, getOwnPropertyDescriptor: $fa6dcceba7c06772$var$r, getOwnPropertyNames: $fa6dcceba7c06772$var$h, getOwnPropertySymbols: $fa6dcceba7c06772$var$o, getPrototypeOf: $fa6dcceba7c06772$var$n } = Object, $fa6dcceba7c06772$var$a = globalThis, $fa6dcceba7c06772$var$c = $fa6dcceba7c06772$var$a.trustedTypes, $fa6dcceba7c06772$var$l = $fa6dcceba7c06772$var$c ? $fa6dcceba7c06772$var$c.emptyScript : "", $fa6dcceba7c06772$var$p = $fa6dcceba7c06772$var$a.reactiveElementPolyfillSupport, $fa6dcceba7c06772$var$d = (t, s)=>t, $fa6dcceba7c06772$export$7312b35fbf521afb = {
    toAttribute (t, s) {
        switch(s){
            case Boolean:
                t = t ? $fa6dcceba7c06772$var$l : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, s) {
        let i = t;
        switch(s){
            case Boolean:
                i = null !== t;
                break;
            case Number:
                i = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    i = JSON.parse(t);
                } catch (t) {
                    i = null;
                }
        }
        return i;
    }
}, $fa6dcceba7c06772$export$53a6892c50694894 = (t, s)=>!$fa6dcceba7c06772$var$i(t, s), $fa6dcceba7c06772$var$y = {
    attribute: !0,
    type: String,
    converter: $fa6dcceba7c06772$export$7312b35fbf521afb,
    reflect: !1,
    hasChanged: $fa6dcceba7c06772$export$53a6892c50694894
};
var $fa6dcceba7c06772$var$_metadata, $fa6dcceba7c06772$var$_litPropertyMetadata;
($fa6dcceba7c06772$var$_metadata = ($fa6dcceba7c06772$var$_Symbol = Symbol).metadata) !== null && $fa6dcceba7c06772$var$_metadata !== void 0 ? $fa6dcceba7c06772$var$_metadata : $fa6dcceba7c06772$var$_Symbol.metadata = Symbol("metadata"), ($fa6dcceba7c06772$var$_litPropertyMetadata = ($fa6dcceba7c06772$var$_a = $fa6dcceba7c06772$var$a).litPropertyMetadata) !== null && $fa6dcceba7c06772$var$_litPropertyMetadata !== void 0 ? $fa6dcceba7c06772$var$_litPropertyMetadata : $fa6dcceba7c06772$var$_a.litPropertyMetadata = new WeakMap;
class $fa6dcceba7c06772$export$c7c07a37856565d extends HTMLElement {
    static addInitializer(t) {
        var _this_l;
        this._$Ei(), ((_this_l = this.l) !== null && _this_l !== void 0 ? _this_l : this.l = []).push(t);
    }
    static get observedAttributes() {
        return this.finalize(), this._$Eh && [
            ...this._$Eh.keys()
        ];
    }
    static createProperty(t, s = $fa6dcceba7c06772$var$y) {
        if (s.state && (s.attribute = !1), this._$Ei(), this.elementProperties.set(t, s), !s.noAccessor) {
            const i = Symbol(), r = this.getPropertyDescriptor(t, i, s);
            void 0 !== r && $fa6dcceba7c06772$var$e(this.prototype, t, r);
        }
    }
    static getPropertyDescriptor(t, s, i) {
        var _r;
        const { get: e, set: h } = (_r = $fa6dcceba7c06772$var$r(this.prototype, t)) !== null && _r !== void 0 ? _r : {
            get () {
                return this[s];
            },
            set (t) {
                this[s] = t;
            }
        };
        return {
            get () {
                return e === null || e === void 0 ? void 0 : e.call(this);
            },
            set (s) {
                const r = e === null || e === void 0 ? void 0 : e.call(this);
                h.call(this, s), this.requestUpdate(t, r, i);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        var _this_elementProperties_get;
        return (_this_elementProperties_get = this.elementProperties.get(t)) !== null && _this_elementProperties_get !== void 0 ? _this_elementProperties_get : $fa6dcceba7c06772$var$y;
    }
    static _$Ei() {
        if (this.hasOwnProperty($fa6dcceba7c06772$var$d("elementProperties"))) return;
        const t = $fa6dcceba7c06772$var$n(this);
        t.finalize(), void 0 !== t.l && (this.l = [
            ...t.l
        ]), this.elementProperties = new Map(t.elementProperties);
    }
    static finalize() {
        if (this.hasOwnProperty($fa6dcceba7c06772$var$d("finalized"))) return;
        if (this.finalized = !0, this._$Ei(), this.hasOwnProperty($fa6dcceba7c06772$var$d("properties"))) {
            const t = this.properties, s = [
                ...$fa6dcceba7c06772$var$h(t),
                ...$fa6dcceba7c06772$var$o(t)
            ];
            for (const i of s)this.createProperty(i, t[i]);
        }
        const t = this[Symbol.metadata];
        if (null !== t) {
            const s = litPropertyMetadata.get(t);
            if (void 0 !== s) for (const [t, i] of s)this.elementProperties.set(t, i);
        }
        this._$Eh = new Map;
        for (const [t, s] of this.elementProperties){
            const i = this._$Eu(t, s);
            void 0 !== i && this._$Eh.set(i, t);
        }
        this.elementStyles = this.finalizeStyles(this.styles);
    }
    static finalizeStyles(s) {
        const i = [];
        if (Array.isArray(s)) {
            const e = new Set(s.flat(1 / 0).reverse());
            for (const s of e)i.unshift((0, $512d98b1c01b30c5$export$ee69dfd951e24778)(s));
        } else void 0 !== s && i.push((0, $512d98b1c01b30c5$export$ee69dfd951e24778)(s));
        return i;
    }
    static _$Eu(t, s) {
        const i = s.attribute;
        return !1 === i ? void 0 : "string" == typeof i ? i : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    _$Ev() {
        var _this_constructor_l;
        this._$Eg = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$ES(), this.requestUpdate(), (_this_constructor_l = this.constructor.l) === null || _this_constructor_l === void 0 ? void 0 : _this_constructor_l.forEach((t)=>t(this));
    }
    addController(t) {
        var _t_hostConnected;
        var _this__$E_;
        ((_this__$E_ = this._$E_) !== null && _this__$E_ !== void 0 ? _this__$E_ : this._$E_ = new Set).add(t), void 0 !== this.renderRoot && this.isConnected && ((_t_hostConnected = t.hostConnected) === null || _t_hostConnected === void 0 ? void 0 : _t_hostConnected.call(t));
    }
    removeController(t) {
        var _this__$E_;
        (_this__$E_ = this._$E_) === null || _this__$E_ === void 0 ? void 0 : _this__$E_.delete(t);
    }
    _$ES() {
        const t = new Map, s = this.constructor.elementProperties;
        for (const i of s.keys())this.hasOwnProperty(i) && (t.set(i, this[i]), delete this[i]);
        t.size > 0 && (this._$Ep = t);
    }
    createRenderRoot() {
        var _this_shadowRoot;
        const t = (_this_shadowRoot = this.shadowRoot) !== null && _this_shadowRoot !== void 0 ? _this_shadowRoot : this.attachShadow(this.constructor.shadowRootOptions);
        return (0, $512d98b1c01b30c5$export$2ca4a66ec4cecb90)(t, this.constructor.elementStyles), t;
    }
    connectedCallback() {
        var _this__$E_;
        var _this_renderRoot;
        (_this_renderRoot = this.renderRoot) !== null && _this_renderRoot !== void 0 ? _this_renderRoot : this.renderRoot = this.createRenderRoot(), this.enableUpdating(!0), (_this__$E_ = this._$E_) === null || _this__$E_ === void 0 ? void 0 : _this__$E_.forEach((t)=>{
            var _t_hostConnected;
            return (_t_hostConnected = t.hostConnected) === null || _t_hostConnected === void 0 ? void 0 : _t_hostConnected.call(t);
        });
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        var _this__$E_;
        (_this__$E_ = this._$E_) === null || _this__$E_ === void 0 ? void 0 : _this__$E_.forEach((t)=>{
            var _t_hostDisconnected;
            return (_t_hostDisconnected = t.hostDisconnected) === null || _t_hostDisconnected === void 0 ? void 0 : _t_hostDisconnected.call(t);
        });
    }
    attributeChangedCallback(t, s, i) {
        this._$AK(t, i);
    }
    _$EO(t, s) {
        const i = this.constructor.elementProperties.get(t), e = this.constructor._$Eu(t, i);
        if (void 0 !== e && !0 === i.reflect) {
            var _i_converter;
            const r = (void 0 !== ((_i_converter = i.converter) === null || _i_converter === void 0 ? void 0 : _i_converter.toAttribute) ? i.converter : $fa6dcceba7c06772$export$7312b35fbf521afb).toAttribute(s, i.type);
            this._$Em = t, null == r ? this.removeAttribute(e) : this.setAttribute(e, r), this._$Em = null;
        }
    }
    _$AK(t, s) {
        const i = this.constructor, e = i._$Eh.get(t);
        if (void 0 !== e && this._$Em !== e) {
            var _t_converter;
            const t = i.getPropertyOptions(e), r = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== ((_t_converter = t.converter) === null || _t_converter === void 0 ? void 0 : _t_converter.fromAttribute) ? t.converter : $fa6dcceba7c06772$export$7312b35fbf521afb;
            this._$Em = e, this[e] = r.fromAttribute(s, t.type), this._$Em = null;
        }
    }
    requestUpdate(t, s, i) {
        if (void 0 !== t) {
            var _i_hasChanged;
            if (i !== null && i !== void 0 ? i : i = this.constructor.getPropertyOptions(t), !((_i_hasChanged = i.hasChanged) !== null && _i_hasChanged !== void 0 ? _i_hasChanged : $fa6dcceba7c06772$export$53a6892c50694894)(this[t], s)) return;
            this.C(t, s, i);
        }
        !1 === this.isUpdatePending && (this._$Eg = this._$EP());
    }
    C(t, s, i) {
        var _this__$ET;
        this._$AL.has(t) || this._$AL.set(t, s), !0 === i.reflect && this._$Em !== t && ((_this__$ET = this._$ET) !== null && _this__$ET !== void 0 ? _this__$ET : this._$ET = new Set).add(t);
    }
    _$EP() {
        var _this = this;
        return (0, $5725b2021a85accb$export$7c398597f8905a1)(function*() {
            _this.isUpdatePending = !0;
            try {
                yield _this._$Eg;
            } catch (t) {
                Promise.reject(t);
            }
            const t = _this.scheduleUpdate();
            return null != t && (yield t), !_this.isUpdatePending;
        })();
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        if (!this.isUpdatePending) return;
        if (!this.hasUpdated) {
            var _this_renderRoot;
            if ((_this_renderRoot = this.renderRoot) !== null && _this_renderRoot !== void 0 ? _this_renderRoot : this.renderRoot = this.createRenderRoot(), this._$Ep) {
                for (const [t, s] of this._$Ep)this[t] = s;
                this._$Ep = void 0;
            }
            const t = this.constructor.elementProperties;
            if (t.size > 0) for (const [s, i] of t)!0 !== i.wrapped || this._$AL.has(s) || void 0 === this[s] || this.C(s, this[s], i);
        }
        let t = !1;
        const s = this._$AL;
        try {
            var _this__$E_;
            t = this.shouldUpdate(s), t ? (this.willUpdate(s), (_this__$E_ = this._$E_) === null || _this__$E_ === void 0 ? void 0 : _this__$E_.forEach((t)=>{
                var _t_hostUpdate;
                return (_t_hostUpdate = t.hostUpdate) === null || _t_hostUpdate === void 0 ? void 0 : _t_hostUpdate.call(t);
            }), this.update(s)) : this._$Ej();
        } catch (s) {
            throw t = !1, this._$Ej(), s;
        }
        t && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        var _this__$E_;
        (_this__$E_ = this._$E_) === null || _this__$E_ === void 0 ? void 0 : _this__$E_.forEach((t)=>{
            var _t_hostUpdated;
            return (_t_hostUpdated = t.hostUpdated) === null || _t_hostUpdated === void 0 ? void 0 : _t_hostUpdated.call(t);
        }), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$Ej() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$Eg;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        this._$ET && (this._$ET = this._$ET.forEach((t)=>this._$EO(t, this[t]))), this._$Ej();
    }
    updated(t) {}
    firstUpdated(t) {}
    constructor(){
        super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
    }
}
var $fa6dcceba7c06772$var$_reactiveElementVersions;
$fa6dcceba7c06772$export$c7c07a37856565d.elementStyles = [], $fa6dcceba7c06772$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, $fa6dcceba7c06772$export$c7c07a37856565d[$fa6dcceba7c06772$var$d("elementProperties")] = new Map, $fa6dcceba7c06772$export$c7c07a37856565d[$fa6dcceba7c06772$var$d("finalized")] = new Map, $fa6dcceba7c06772$var$p === null || $fa6dcceba7c06772$var$p === void 0 ? void 0 : $fa6dcceba7c06772$var$p({
    ReactiveElement: $fa6dcceba7c06772$export$c7c07a37856565d
}), (($fa6dcceba7c06772$var$_reactiveElementVersions = ($fa6dcceba7c06772$var$_a1 = $fa6dcceba7c06772$var$a).reactiveElementVersions) !== null && $fa6dcceba7c06772$var$_reactiveElementVersions !== void 0 ? $fa6dcceba7c06772$var$_reactiveElementVersions : $fa6dcceba7c06772$var$_a1.reactiveElementVersions = []).push("2.0.3");


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $594a69b07daf0e84$var$_t;
const $594a69b07daf0e84$var$t = globalThis, $594a69b07daf0e84$var$i = $594a69b07daf0e84$var$t.trustedTypes, $594a69b07daf0e84$var$s = $594a69b07daf0e84$var$i ? $594a69b07daf0e84$var$i.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $594a69b07daf0e84$var$e = "$lit$", $594a69b07daf0e84$var$h = `lit$${(Math.random() + "").slice(9)}$`, $594a69b07daf0e84$var$o = "?" + $594a69b07daf0e84$var$h, $594a69b07daf0e84$var$n = `<${$594a69b07daf0e84$var$o}>`, $594a69b07daf0e84$var$r = document, $594a69b07daf0e84$var$l = ()=>$594a69b07daf0e84$var$r.createComment(""), $594a69b07daf0e84$var$c = (t)=>null === t || "object" != typeof t && "function" != typeof t, $594a69b07daf0e84$var$a = Array.isArray, $594a69b07daf0e84$var$u = (t)=>$594a69b07daf0e84$var$a(t) || "function" == typeof (t === null || t === void 0 ? void 0 : t[Symbol.iterator]), $594a69b07daf0e84$var$d = "[ 	\n\f\r]", $594a69b07daf0e84$var$f = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $594a69b07daf0e84$var$v = /-->/g, $594a69b07daf0e84$var$_ = />/g, $594a69b07daf0e84$var$m = RegExp(`>|${$594a69b07daf0e84$var$d}(?:([^\\s"'>=/]+)(${$594a69b07daf0e84$var$d}*=${$594a69b07daf0e84$var$d}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $594a69b07daf0e84$var$p = /'/g, $594a69b07daf0e84$var$g = /"/g, $594a69b07daf0e84$var$$ = /^(?:script|style|textarea|title)$/i, $594a69b07daf0e84$var$y = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $594a69b07daf0e84$export$c0bb0b647f701bb5 = $594a69b07daf0e84$var$y(1), $594a69b07daf0e84$export$7ed1367e7fa1ad68 = $594a69b07daf0e84$var$y(2), $594a69b07daf0e84$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $594a69b07daf0e84$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $594a69b07daf0e84$var$A = new WeakMap, $594a69b07daf0e84$var$E = $594a69b07daf0e84$var$r.createTreeWalker($594a69b07daf0e84$var$r, 129);
function $594a69b07daf0e84$var$C(t, i) {
    if (!Array.isArray(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $594a69b07daf0e84$var$s ? $594a69b07daf0e84$var$s.createHTML(i) : i;
}
const $594a69b07daf0e84$var$P = (t, i)=>{
    const s = t.length - 1, o = [];
    let r, l = 2 === i ? "<svg>" : "", c = $594a69b07daf0e84$var$f;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let a, u, d = -1, y = 0;
        for(; y < s.length && (c.lastIndex = y, u = c.exec(s), null !== u);)y = c.lastIndex, c === $594a69b07daf0e84$var$f ? "!--" === u[1] ? c = $594a69b07daf0e84$var$v : void 0 !== u[1] ? c = $594a69b07daf0e84$var$_ : void 0 !== u[2] ? ($594a69b07daf0e84$var$$.test(u[2]) && (r = RegExp("</" + u[2], "g")), c = $594a69b07daf0e84$var$m) : void 0 !== u[3] && (c = $594a69b07daf0e84$var$m) : c === $594a69b07daf0e84$var$m ? ">" === u[0] ? (c = r !== null && r !== void 0 ? r : $594a69b07daf0e84$var$f, d = -1) : void 0 === u[1] ? d = -2 : (d = c.lastIndex - u[2].length, a = u[1], c = void 0 === u[3] ? $594a69b07daf0e84$var$m : '"' === u[3] ? $594a69b07daf0e84$var$g : $594a69b07daf0e84$var$p) : c === $594a69b07daf0e84$var$g || c === $594a69b07daf0e84$var$p ? c = $594a69b07daf0e84$var$m : c === $594a69b07daf0e84$var$v || c === $594a69b07daf0e84$var$_ ? c = $594a69b07daf0e84$var$f : (c = $594a69b07daf0e84$var$m, r = void 0);
        const x = c === $594a69b07daf0e84$var$m && t[i + 1].startsWith("/>") ? " " : "";
        l += c === $594a69b07daf0e84$var$f ? s + $594a69b07daf0e84$var$n : d >= 0 ? (o.push(a), s.slice(0, d) + $594a69b07daf0e84$var$e + s.slice(d) + $594a69b07daf0e84$var$h + x) : s + $594a69b07daf0e84$var$h + (-2 === d ? i : x);
    }
    return [
        $594a69b07daf0e84$var$C(t, l + (t[s] || "<?>") + (2 === i ? "</svg>" : "")),
        o
    ];
};
class $594a69b07daf0e84$var$V {
    static createElement(t, i) {
        const s = $594a69b07daf0e84$var$r.createElement("template");
        return s.innerHTML = t, s;
    }
    constructor({ strings: t, _$litType$: s }, n){
        let r;
        this.parts = [];
        let c = 0, a = 0;
        const u = t.length - 1, d = this.parts, [f, v] = $594a69b07daf0e84$var$P(t, s);
        if (this.el = $594a69b07daf0e84$var$V.createElement(f, n), $594a69b07daf0e84$var$E.currentNode = this.el.content, 2 === s) {
            const t = this.el.content.firstChild;
            t.replaceWith(...t.childNodes);
        }
        for(; null !== (r = $594a69b07daf0e84$var$E.nextNode()) && d.length < u;){
            if (1 === r.nodeType) {
                if (r.hasAttributes()) for (const t of r.getAttributeNames())if (t.endsWith($594a69b07daf0e84$var$e)) {
                    const i = v[a++], s = r.getAttribute(t).split($594a69b07daf0e84$var$h), e = /([.?@])?(.*)/.exec(i);
                    d.push({
                        type: 1,
                        index: c,
                        name: e[2],
                        strings: s,
                        ctor: "." === e[1] ? $594a69b07daf0e84$var$k : "?" === e[1] ? $594a69b07daf0e84$var$H : "@" === e[1] ? $594a69b07daf0e84$var$I : $594a69b07daf0e84$var$R
                    }), r.removeAttribute(t);
                } else t.startsWith($594a69b07daf0e84$var$h) && (d.push({
                    type: 6,
                    index: c
                }), r.removeAttribute(t));
                if ($594a69b07daf0e84$var$$.test(r.tagName)) {
                    const t = r.textContent.split($594a69b07daf0e84$var$h), s = t.length - 1;
                    if (s > 0) {
                        r.textContent = $594a69b07daf0e84$var$i ? $594a69b07daf0e84$var$i.emptyScript : "";
                        for(let i = 0; i < s; i++)r.append(t[i], $594a69b07daf0e84$var$l()), $594a69b07daf0e84$var$E.nextNode(), d.push({
                            type: 2,
                            index: ++c
                        });
                        r.append(t[s], $594a69b07daf0e84$var$l());
                    }
                }
            } else if (8 === r.nodeType) {
                if (r.data === $594a69b07daf0e84$var$o) d.push({
                    type: 2,
                    index: c
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = r.data.indexOf($594a69b07daf0e84$var$h, t + 1));)d.push({
                        type: 7,
                        index: c
                    }), t += $594a69b07daf0e84$var$h.length - 1;
                }
            }
            c++;
        }
    }
}
function $594a69b07daf0e84$var$N(t, i, s = t, e) {
    var _s__$Co, _h__$AO;
    var _s;
    if (i === $594a69b07daf0e84$export$9c068ae9cc5db4e8) return i;
    let h = void 0 !== e ? (_s__$Co = s._$Co) === null || _s__$Co === void 0 ? void 0 : _s__$Co[e] : s._$Cl;
    const o = $594a69b07daf0e84$var$c(i) ? void 0 : i._$litDirective$;
    var __$Co;
    return (h === null || h === void 0 ? void 0 : h.constructor) !== o && (h === null || h === void 0 ? void 0 : (_h__$AO = h._$AO) === null || _h__$AO === void 0 ? void 0 : _h__$AO.call(h, !1), void 0 === o ? h = void 0 : (h = new o(t), h._$AT(t, s, e)), void 0 !== e ? ((__$Co = (_s = s)._$Co) !== null && __$Co !== void 0 ? __$Co : _s._$Co = [])[e] = h : s._$Cl = h), void 0 !== h && (i = $594a69b07daf0e84$var$N(t, h._$AS(t, i.values), h, e)), i;
}
class $594a69b07daf0e84$var$S {
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        var _t_creationScope;
        const { el: { content: i }, parts: s } = this._$AD, e = ((_t_creationScope = t === null || t === void 0 ? void 0 : t.creationScope) !== null && _t_creationScope !== void 0 ? _t_creationScope : $594a69b07daf0e84$var$r).importNode(i, !0);
        $594a69b07daf0e84$var$E.currentNode = e;
        let h = $594a69b07daf0e84$var$E.nextNode(), o = 0, n = 0, l = s[0];
        for(; void 0 !== l;){
            if (o === l.index) {
                let i;
                2 === l.type ? i = new $594a69b07daf0e84$var$M(h, h.nextSibling, this, t) : 1 === l.type ? i = new l.ctor(h, l.name, l.strings, this, t) : 6 === l.type && (i = new $594a69b07daf0e84$var$L(h, this, t)), this._$AV.push(i), l = s[++n];
            }
            o !== (l === null || l === void 0 ? void 0 : l.index) && (h = $594a69b07daf0e84$var$E.nextNode(), o++);
        }
        return $594a69b07daf0e84$var$E.currentNode = $594a69b07daf0e84$var$r, e;
    }
    p(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
}
class $594a69b07daf0e84$var$M {
    get _$AU() {
        var _this__$AM;
        var _this__$AM__$AU;
        return (_this__$AM__$AU = (_this__$AM = this._$AM) === null || _this__$AM === void 0 ? void 0 : _this__$AM._$AU) !== null && _this__$AM__$AU !== void 0 ? _this__$AM__$AU : this._$Cv;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === (t === null || t === void 0 ? void 0 : t.nodeType) && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $594a69b07daf0e84$var$N(this, t, i), $594a69b07daf0e84$var$c(t) ? t === $594a69b07daf0e84$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $594a69b07daf0e84$export$45b790e32b2810ee && this._$AR(), this._$AH = $594a69b07daf0e84$export$45b790e32b2810ee) : t !== this._$AH && t !== $594a69b07daf0e84$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.g(t) : void 0 !== t.nodeType ? this.$(t) : $594a69b07daf0e84$var$u(t) ? this.T(t) : this._(t);
    }
    k(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    $(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.k(t));
    }
    _(t) {
        this._$AH !== $594a69b07daf0e84$export$45b790e32b2810ee && $594a69b07daf0e84$var$c(this._$AH) ? this._$AA.nextSibling.data = t : this.$($594a69b07daf0e84$var$r.createTextNode(t)), this._$AH = t;
    }
    g(t) {
        var _this__$AH;
        const { values: i, _$litType$: s } = t, e = "number" == typeof s ? this._$AC(t) : (void 0 === s.el && (s.el = $594a69b07daf0e84$var$V.createElement($594a69b07daf0e84$var$C(s.h, s.h[0]), this.options)), s);
        if (((_this__$AH = this._$AH) === null || _this__$AH === void 0 ? void 0 : _this__$AH._$AD) === e) this._$AH.p(i);
        else {
            const t = new $594a69b07daf0e84$var$S(e, this), s = t.u(this.options);
            t.p(i), this.$(s), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $594a69b07daf0e84$var$A.get(t.strings);
        return void 0 === i && $594a69b07daf0e84$var$A.set(t.strings, i = new $594a69b07daf0e84$var$V(t)), i;
    }
    T(t) {
        $594a69b07daf0e84$var$a(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const h of t)e === i.length ? i.push(s = new $594a69b07daf0e84$var$M(this.k($594a69b07daf0e84$var$l()), this.k($594a69b07daf0e84$var$l()), this, this.options)) : s = i[e], s._$AI(h), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        var _this__$AP, _this;
        for((_this__$AP = (_this = this)._$AP) === null || _this__$AP === void 0 ? void 0 : _this__$AP.call(_this, !1, !0, i); t && t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        var _this__$AP, _this;
        void 0 === this._$AM && (this._$Cv = t, (_this__$AP = (_this = this)._$AP) === null || _this__$AP === void 0 ? void 0 : _this__$AP.call(_this, t));
    }
    constructor(t, i, s, e){
        var _e_isConnected;
        this.type = 2, this._$AH = $594a69b07daf0e84$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cv = (_e_isConnected = e === null || e === void 0 ? void 0 : e.isConnected) !== null && _e_isConnected !== void 0 ? _e_isConnected : !0;
    }
}
class $594a69b07daf0e84$var$R {
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t, i = this, s, e) {
        const h = this.strings;
        let o = !1;
        if (void 0 === h) t = $594a69b07daf0e84$var$N(this, t, i, 0), o = !$594a69b07daf0e84$var$c(t) || t !== this._$AH && t !== $594a69b07daf0e84$export$9c068ae9cc5db4e8, o && (this._$AH = t);
        else {
            const e = t;
            let n, r;
            for(t = h[0], n = 0; n < h.length - 1; n++)r = $594a69b07daf0e84$var$N(this, e[s + n], i, n), r === $594a69b07daf0e84$export$9c068ae9cc5db4e8 && (r = this._$AH[n]), o || (o = !$594a69b07daf0e84$var$c(r) || r !== this._$AH[n]), r === $594a69b07daf0e84$export$45b790e32b2810ee ? t = $594a69b07daf0e84$export$45b790e32b2810ee : t !== $594a69b07daf0e84$export$45b790e32b2810ee && (t += (r !== null && r !== void 0 ? r : "") + h[n + 1]), this._$AH[n] = r;
        }
        o && !e && this.O(t);
    }
    O(t) {
        t === $594a69b07daf0e84$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t !== null && t !== void 0 ? t : "");
    }
    constructor(t, i, s, e, h){
        this.type = 1, this._$AH = $594a69b07daf0e84$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = h, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $594a69b07daf0e84$export$45b790e32b2810ee;
    }
}
class $594a69b07daf0e84$var$k extends $594a69b07daf0e84$var$R {
    O(t) {
        this.element[this.name] = t === $594a69b07daf0e84$export$45b790e32b2810ee ? void 0 : t;
    }
    constructor(){
        super(...arguments), this.type = 3;
    }
}
class $594a69b07daf0e84$var$H extends $594a69b07daf0e84$var$R {
    O(t) {
        this.element.toggleAttribute(this.name, !!t && t !== $594a69b07daf0e84$export$45b790e32b2810ee);
    }
    constructor(){
        super(...arguments), this.type = 4;
    }
}
class $594a69b07daf0e84$var$I extends $594a69b07daf0e84$var$R {
    _$AI(t, i = this) {
        var _N;
        if ((t = (_N = $594a69b07daf0e84$var$N(this, t, i, 0)) !== null && _N !== void 0 ? _N : $594a69b07daf0e84$export$45b790e32b2810ee) === $594a69b07daf0e84$export$9c068ae9cc5db4e8) return;
        const s = this._$AH, e = t === $594a69b07daf0e84$export$45b790e32b2810ee && s !== $594a69b07daf0e84$export$45b790e32b2810ee || t.capture !== s.capture || t.once !== s.once || t.passive !== s.passive, h = t !== $594a69b07daf0e84$export$45b790e32b2810ee && (s === $594a69b07daf0e84$export$45b790e32b2810ee || e);
        e && this.element.removeEventListener(this.name, this, s), h && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        var _this_options;
        var _this_options_host;
        "function" == typeof this._$AH ? this._$AH.call((_this_options_host = (_this_options = this.options) === null || _this_options === void 0 ? void 0 : _this_options.host) !== null && _this_options_host !== void 0 ? _this_options_host : this.element, t) : this._$AH.handleEvent(t);
    }
    constructor(t, i, s, e, h){
        super(t, i, s, e, h), this.type = 5;
    }
}
class $594a69b07daf0e84$var$L {
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $594a69b07daf0e84$var$N(this, t);
    }
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
}
const $594a69b07daf0e84$export$8613d1ca9052b22e = {
    j: $594a69b07daf0e84$var$e,
    P: $594a69b07daf0e84$var$h,
    A: $594a69b07daf0e84$var$o,
    C: 1,
    M: $594a69b07daf0e84$var$P,
    L: $594a69b07daf0e84$var$S,
    R: $594a69b07daf0e84$var$u,
    V: $594a69b07daf0e84$var$N,
    D: $594a69b07daf0e84$var$M,
    I: $594a69b07daf0e84$var$R,
    H: $594a69b07daf0e84$var$H,
    N: $594a69b07daf0e84$var$I,
    U: $594a69b07daf0e84$var$k,
    B: $594a69b07daf0e84$var$L
}, $594a69b07daf0e84$var$Z = $594a69b07daf0e84$var$t.litHtmlPolyfillSupport;
var $594a69b07daf0e84$var$_litHtmlVersions;
$594a69b07daf0e84$var$Z === null || $594a69b07daf0e84$var$Z === void 0 ? void 0 : $594a69b07daf0e84$var$Z($594a69b07daf0e84$var$V, $594a69b07daf0e84$var$M), (($594a69b07daf0e84$var$_litHtmlVersions = ($594a69b07daf0e84$var$_t = $594a69b07daf0e84$var$t).litHtmlVersions) !== null && $594a69b07daf0e84$var$_litHtmlVersions !== void 0 ? $594a69b07daf0e84$var$_litHtmlVersions : $594a69b07daf0e84$var$_t.litHtmlVersions = []).push("3.1.1");
const $594a69b07daf0e84$export$b3890eb0ae9dca99 = (t, i, s)=>{
    var _s_renderBefore;
    const e = (_s_renderBefore = s === null || s === void 0 ? void 0 : s.renderBefore) !== null && _s_renderBefore !== void 0 ? _s_renderBefore : i;
    let h = e._$litPart$;
    if (void 0 === h) {
        var _s_renderBefore1;
        const t = (_s_renderBefore1 = s === null || s === void 0 ? void 0 : s.renderBefore) !== null && _s_renderBefore1 !== void 0 ? _s_renderBefore1 : null;
        e._$litPart$ = h = new $594a69b07daf0e84$var$M(i.insertBefore($594a69b07daf0e84$var$l(), t), t, void 0, s !== null && s !== void 0 ? s : {});
    }
    return h._$AI(t), h;
};




var $e6b2ca66b51a68a3$var$_globalThis_litElementHydrateSupport, $e6b2ca66b51a68a3$var$_globalThis;
var $e6b2ca66b51a68a3$var$_globalThis1;
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class $e6b2ca66b51a68a3$export$3f2f9f5909897157 extends (0, $fa6dcceba7c06772$export$c7c07a37856565d) {
    createRenderRoot() {
        var _this_renderOptions;
        const t = super.createRenderRoot();
        var _renderBefore;
        return (_renderBefore = (_this_renderOptions = this.renderOptions).renderBefore) !== null && _renderBefore !== void 0 ? _renderBefore : _this_renderOptions.renderBefore = t.firstChild, t;
    }
    update(t) {
        const i = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = (0, $594a69b07daf0e84$export$b3890eb0ae9dca99)(i, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        var _this__$Do;
        super.connectedCallback(), (_this__$Do = this._$Do) === null || _this__$Do === void 0 ? void 0 : _this__$Do.setConnected(!0);
    }
    disconnectedCallback() {
        var _this__$Do;
        super.disconnectedCallback(), (_this__$Do = this._$Do) === null || _this__$Do === void 0 ? void 0 : _this__$Do.setConnected(!1);
    }
    render() {
        return 0, $594a69b07daf0e84$export$9c068ae9cc5db4e8;
    }
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Do = void 0;
    }
}
$e6b2ca66b51a68a3$export$3f2f9f5909897157._$litElement$ = !0, $e6b2ca66b51a68a3$export$3f2f9f5909897157["finalized"] = !0, ($e6b2ca66b51a68a3$var$_globalThis_litElementHydrateSupport = ($e6b2ca66b51a68a3$var$_globalThis = globalThis).litElementHydrateSupport) === null || $e6b2ca66b51a68a3$var$_globalThis_litElementHydrateSupport === void 0 ? void 0 : $e6b2ca66b51a68a3$var$_globalThis_litElementHydrateSupport.call($e6b2ca66b51a68a3$var$_globalThis, {
    LitElement: $e6b2ca66b51a68a3$export$3f2f9f5909897157
});
const $e6b2ca66b51a68a3$var$r = globalThis.litElementPolyfillSupport;
$e6b2ca66b51a68a3$var$r === null || $e6b2ca66b51a68a3$var$r === void 0 ? void 0 : $e6b2ca66b51a68a3$var$r({
    LitElement: $e6b2ca66b51a68a3$export$3f2f9f5909897157
});
const $e6b2ca66b51a68a3$export$f5c524615a7708d6 = {
    _$AK: (t, e, i)=>{
        t._$AK(e, i);
    },
    _$AL: (t)=>t._$AL
};
var $e6b2ca66b51a68a3$var$_litElementVersions;
(($e6b2ca66b51a68a3$var$_litElementVersions = ($e6b2ca66b51a68a3$var$_globalThis1 = globalThis).litElementVersions) !== null && $e6b2ca66b51a68a3$var$_litElementVersions !== void 0 ? $e6b2ca66b51a68a3$var$_litElementVersions : $e6b2ca66b51a68a3$var$_globalThis1.litElementVersions = []).push("4.0.3");


/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $c1dd1110ac347775$export$6acf61af03e62db = !1;




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $8b53573f9e3092a2$export$da64fc29f17f9d0e = (t)=>(e, o)=>{
        void 0 !== o ? o.addInitializer(()=>{
            customElements.define(t, e);
        }) : customElements.define(t, e);
    };


function $bfdb6eef2bb17838$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $429981144fb29922$export$581ff339ea0ba762(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $bfdb6eef2bb17838$export$1e71eb4bef00f6b0)(target, key, source[key]);
        });
    }
    return target;
}


function $a6ebb6f5eece5690$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a6ebb6f5eece5690$export$4fa2f4023c9cbda5(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $a6ebb6f5eece5690$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $716e449a79333d97$var$o = {
    attribute: !0,
    type: String,
    converter: (0, $fa6dcceba7c06772$export$7312b35fbf521afb),
    reflect: !1,
    hasChanged: (0, $fa6dcceba7c06772$export$53a6892c50694894)
}, $716e449a79333d97$export$8d623b1670eb40f4 = (t = $716e449a79333d97$var$o, e, r)=>{
    const { kind: n, metadata: i } = r;
    let s = globalThis.litPropertyMetadata.get(i);
    if (void 0 === s && globalThis.litPropertyMetadata.set(i, s = new Map), s.set(r.name, t), "accessor" === n) {
        const { name: o } = r;
        return {
            set (r) {
                const n = e.get.call(this);
                e.set.call(this, r), this.requestUpdate(o, n, t);
            },
            init (e) {
                return void 0 !== e && this.C(o, void 0, t), e;
            }
        };
    }
    if ("setter" === n) {
        const { name: o } = r;
        return function(r) {
            const n = this[o];
            e.call(this, r), this.requestUpdate(o, n, t);
        };
    }
    throw Error("Unsupported decorator location: " + n);
};
function $716e449a79333d97$export$d541bacb2bda4494(t) {
    return (e, o)=>"object" == typeof o ? $716e449a79333d97$export$8d623b1670eb40f4(t, e, o) : ((t, e, o)=>{
            const r = e.hasOwnProperty(o);
            return e.constructor.createProperty(o, r ? (0, $a6ebb6f5eece5690$export$4fa2f4023c9cbda5)((0, $429981144fb29922$export$581ff339ea0ba762)({}, t), {
                wrapped: !0
            }) : t), r ? Object.getOwnPropertyDescriptor(e, o) : void 0;
        })(t, e, o);
}





/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $9b2c697b13cdf03f$export$ca000e230c0caa3e(r) {
    return (0, $716e449a79333d97$export$d541bacb2bda4494)((0, $a6ebb6f5eece5690$export$4fa2f4023c9cbda5)((0, $429981144fb29922$export$581ff339ea0ba762)({}, r), {
        state: !0,
        attribute: !1
    }));
}


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $3c47a1412de1ec6b$export$b2b799818fbabcf3(t) {
    return (n, o)=>{
        const c = "function" == typeof n ? n : n[o];
        Object.assign(c, t);
    };
}


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $a88ae46290fa8cf6$export$51987bb50e1f6752 = (e, t, c)=>(c.configurable = !0, c.enumerable = !0, Reflect.decorate && "object" != typeof t && Object.defineProperty(e, t, c), c);


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $5c3ec822a974318f$export$2fa187e846a241c4(e, r) {
    return (n, s, i)=>{
        const o = (t)=>{
            var _t_renderRoot;
            var _t_renderRoot_querySelector;
            return (_t_renderRoot_querySelector = (_t_renderRoot = t.renderRoot) === null || _t_renderRoot === void 0 ? void 0 : _t_renderRoot.querySelector(e)) !== null && _t_renderRoot_querySelector !== void 0 ? _t_renderRoot_querySelector : null;
        };
        if (r) {
            const { get: e, set: r } = "object" == typeof s ? n : i !== null && i !== void 0 ? i : (()=>{
                const t = Symbol();
                return {
                    get () {
                        return this[t];
                    },
                    set (e) {
                        this[t] = e;
                    }
                };
            })();
            return (0, $a88ae46290fa8cf6$export$51987bb50e1f6752)(n, s, {
                get () {
                    let t = e.call(this);
                    return void 0 === t && (t = o(this), (null !== t || this.hasUpdated) && r.call(this, t)), t;
                }
            });
        }
        return (0, $a88ae46290fa8cf6$export$51987bb50e1f6752)(n, s, {
            get () {
                return o(this);
            }
        });
    };
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ let $eb2745a8b8cefbaa$var$e;
function $eb2745a8b8cefbaa$export$dcd0d083aa86c355(r) {
    return (n, o)=>(0, $a88ae46290fa8cf6$export$51987bb50e1f6752)(n, o, {
            get () {
                var _this_renderRoot;
                return ((_this_renderRoot = this.renderRoot) !== null && _this_renderRoot !== void 0 ? _this_renderRoot : $eb2745a8b8cefbaa$var$e !== null && $eb2745a8b8cefbaa$var$e !== void 0 ? $eb2745a8b8cefbaa$var$e : $eb2745a8b8cefbaa$var$e = document.createDocumentFragment()).querySelectorAll(r);
            }
        });
}




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $d93bb156f20d4d7d$export$163dfc35cc43f240(r) {
    return (n, e)=>(0, $a88ae46290fa8cf6$export$51987bb50e1f6752)(n, e, {
            get () {
                return (0, $5725b2021a85accb$export$7c398597f8905a1)(function*() {
                    var _this_renderRoot;
                    var _this_renderRoot_querySelector;
                    return yield this.updateComplete, (_this_renderRoot_querySelector = (_this_renderRoot = this.renderRoot) === null || _this_renderRoot === void 0 ? void 0 : _this_renderRoot.querySelector(r)) !== null && _this_renderRoot_querySelector !== void 0 ? _this_renderRoot_querySelector : null;
                }).apply(this);
            }
        });
}



/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $7527ffaaa4836e98$export$4682af2d9ee91415(o) {
    return (e, n)=>{
        const { slot: r, selector: s } = o !== null && o !== void 0 ? o : {}, c = "slot" + (r ? `[name=${r}]` : ":not([name])");
        return (0, $a88ae46290fa8cf6$export$51987bb50e1f6752)(e, n, {
            get () {
                var _this_renderRoot;
                var _t_assignedElements;
                const t = (_this_renderRoot = this.renderRoot) === null || _this_renderRoot === void 0 ? void 0 : _this_renderRoot.querySelector(c), e = (_t_assignedElements = t === null || t === void 0 ? void 0 : t.assignedElements(o)) !== null && _t_assignedElements !== void 0 ? _t_assignedElements : [];
                return void 0 === s ? e : e.filter((t)=>t.matches(s));
            }
        });
    };
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $9e56023afc2d6515$export$1bdbe53f9df1b8(n) {
    return (o, r)=>{
        const { slot: e } = n !== null && n !== void 0 ? n : {}, s = "slot" + (e ? `[name=${e}]` : ":not([name])");
        return (0, $a88ae46290fa8cf6$export$51987bb50e1f6752)(o, r, {
            get () {
                var _this_renderRoot;
                const t = (_this_renderRoot = this.renderRoot) === null || _this_renderRoot === void 0 ? void 0 : _this_renderRoot.querySelector(s);
                var _t_assignedNodes;
                return (_t_assignedNodes = t === null || t === void 0 ? void 0 : t.assignedNodes(n)) !== null && _t_assignedNodes !== void 0 ? _t_assignedNodes : [];
            }
        });
    };
}





/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $8dfcc6d1972864fd$export$9ba3b3f20a85bfa = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
}, $8dfcc6d1972864fd$export$99b43ad1ed32e735 = (t)=>(...e)=>({
            _$litDirective$: t,
            values: e
        });
class $8dfcc6d1972864fd$export$befdefbdce210f91 {
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(t, e, i) {
        this._$Ct = t, this._$AM = e, this._$Ci = i;
    }
    _$AS(t, e) {
        return this.update(t, e);
    }
    update(t, e) {
        return this.render(...e);
    }
    constructor(t){}
}


/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $a5c28c9fe8362843$var$n = "important", $a5c28c9fe8362843$var$i = " !" + $a5c28c9fe8362843$var$n, $a5c28c9fe8362843$export$1e5b4ce2fa884e6a = (0, $8dfcc6d1972864fd$export$99b43ad1ed32e735)(class extends (0, $8dfcc6d1972864fd$export$befdefbdce210f91) {
    render(t) {
        return Object.keys(t).reduce((e, r)=>{
            const s = t[r];
            return null == s ? e : e + `${r = r.includes("-") ? r : r.replace(/(?:^(webkit|moz|ms|o)|)(?=[A-Z])/g, "-$&").toLowerCase()}:${s};`;
        }, "");
    }
    update(e, [r]) {
        const { style: s } = e.element;
        if (void 0 === this.ut) return this.ut = new Set(Object.keys(r)), this.render(r);
        for (const t of this.ut)null == r[t] && (this.ut.delete(t), t.includes("-") ? s.removeProperty(t) : s[t] = null);
        for(const t in r){
            const e = r[t];
            if (null != e) {
                this.ut.add(t);
                const r = "string" == typeof e && e.endsWith($a5c28c9fe8362843$var$i);
                t.includes("-") || r ? s.setProperty(t, r ? e.slice(0, -11) : e, r ? $a5c28c9fe8362843$var$n : "") : s[t] = e;
            }
        }
        return 0, $594a69b07daf0e84$export$9c068ae9cc5db4e8;
    }
    constructor(t){
        var _t_strings;
        if (super(t), t.type !== (0, $8dfcc6d1972864fd$export$9ba3b3f20a85bfa).ATTRIBUTE || "style" !== t.name || ((_t_strings = t.strings) === null || _t_strings === void 0 ? void 0 : _t_strings.length) > 2) throw Error("The `styleMap` directive must be used in the `style` attribute and must be the only part in the attribute.");
    }
});





/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $5df1285dd8b8b456$export$f68dd208b5df064d = (o)=>o !== null && o !== void 0 ? o : (0, $594a69b07daf0e84$export$45b790e32b2810ee);




// src/core.ts


function $983f4a4cdab09070$export$7a4a7e38737aceb4(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function $97429791653469d6$export$69fdd232f62cde60(source, excluded) {
    if (source == null) return {};
    var target = (0, $983f4a4cdab09070$export$7a4a7e38737aceb4)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}






var $bd12eb89d57b0e14$export$2e2bcd8739ae039 = {
    "images.ctfassets.net": "contentful",
    "cdn.builder.io": "builder.io",
    "images.prismic.io": "imgix",
    "www.datocms-assets.com": "imgix",
    "cdn.sanity.io": "imgix",
    "images.unsplash.com": "imgix",
    "cdn.shopify.com": "shopify",
    "s7d1.scene7.com": "scene7",
    "ip.keycdn.com": "keycdn",
    "assets.caisy.io": "bunny",
    "images.contentstack.io": "contentstack"
};


var $d72f1995c0b79ae5$export$2e2bcd8739ae039 = {
    "imgix.net": "imgix",
    "files.wordpress.com": "wordpress",
    "b-cdn.net": "bunny",
    "storyblok.com": "storyblok",
    "kc-usercontent.com": "kontent.ai",
    "cloudinary.com": "cloudinary",
    "kxcdn.com": "keycdn",
    "imgeng.in": "imageengine",
    "imagekit.io": "imagekit",
    "cloudimg.io": "cloudimage"
};


var $26877cfc48278d75$export$2e2bcd8739ae039 = {
    "/cdn-cgi/image/": "cloudflare",
    "/cdn-cgi/imagedelivery/": "cloudflare_images",
    "/_next/image": "nextjs",
    "/_next/static": "nextjs",
    "/_vercel/image": "vercel",
    "/is/image": "scene7",
    "/_ipx/": "ipx",
    "/_image": "astro",
    "/.netlify/images": "netlify"
};


const $44972171fb249819$export$633dc235a7124180 = (value)=>{
    if (!value) return value;
    const num = Number(value);
    return isNaN(num) ? value : Math.round(num);
};
const $44972171fb249819$export$b3ce47f2ef28a28 = (url, key, value, deleteExisting, roundValue)=>{
    if (value) {
        if (roundValue) value = $44972171fb249819$export$633dc235a7124180(value);
        url.searchParams.set(key, value.toString());
    } else if (deleteExisting) url.searchParams.delete(key);
};
const $44972171fb249819$export$afb2828c24f592c8 = (url, key, value)=>{
    if (!url.searchParams.has(key)) url.searchParams.set(key, value.toString());
};
const $44972171fb249819$export$d8c59ae245c15523 = (url, key)=>{
    const value = Number(url.searchParams.get(key));
    return isNaN(value) ? undefined : value;
};
const $44972171fb249819$export$4ebdca5513a016fe = (url)=>{
    const { pathname: pathname, search: search } = url;
    return `${pathname}${search}`;
};
const $44972171fb249819$export$9a5ff27ac96579c6 = (url)=>{
    return url.hostname === "n" ? $44972171fb249819$export$4ebdca5513a016fe(url) : url.toString();
};
const $44972171fb249819$export$1758be3e5622c165 = (url, base)=>{
    return typeof url === "string" ? new URL(url, base !== null && base !== void 0 ? base : "http://n/") : url;
};


const $697dc7106d3c3089$var$cdnDomains = new Map(Object.entries((0, $bd12eb89d57b0e14$export$2e2bcd8739ae039)));
const $697dc7106d3c3089$var$cdnSubdomains = Object.entries((0, $d72f1995c0b79ae5$export$2e2bcd8739ae039));
function $697dc7106d3c3089$export$e1399f03bc6dd3e5(url) {
    return $697dc7106d3c3089$export$2192df6ac6dfdd0b(url) || $697dc7106d3c3089$export$7d68d9a65a928724(url);
}
function $697dc7106d3c3089$export$2192df6ac6dfdd0b(url) {
    if (typeof url === "string" && !url.startsWith("https://")) return false;
    const { hostname: hostname } = (0, $44972171fb249819$export$1758be3e5622c165)(url);
    if ($697dc7106d3c3089$var$cdnDomains.has(hostname)) return $697dc7106d3c3089$var$cdnDomains.get(hostname);
    for (const [subdomain, cdn] of $697dc7106d3c3089$var$cdnSubdomains){
        if (hostname.endsWith(`.${subdomain}`)) return cdn;
    }
    return false;
}
function $697dc7106d3c3089$export$7d68d9a65a928724(url) {
    // Allow relative URLs
    const { pathname: pathname } = (0, $44972171fb249819$export$1758be3e5622c165)(url);
    for (const [prefix, cdn] of Object.entries((0, $26877cfc48278d75$export$2e2bcd8739ae039))){
        if (pathname.startsWith(prefix)) return cdn;
    }
    return false;
}



const $0a7c0d9850e5a54e$export$98e6a39c04603d36 = (url)=>{
    const parsedUrl = (0, $44972171fb249819$export$1758be3e5622c165)(url);
    const fit = parsedUrl.searchParams.get("fit") || undefined;
    const width = (0, $44972171fb249819$export$d8c59ae245c15523)(parsedUrl, "w");
    const height = (0, $44972171fb249819$export$d8c59ae245c15523)(parsedUrl, "h");
    const quality = (0, $44972171fb249819$export$d8c59ae245c15523)(parsedUrl, "q");
    const format = parsedUrl.searchParams.get("fm") || undefined;
    parsedUrl.search = "";
    return {
        width: width,
        height: height,
        format: format,
        base: parsedUrl.toString(),
        params: {
            fit: fit,
            quality: quality
        },
        cdn: "contentful"
    };
};
const $0a7c0d9850e5a54e$export$51186ad6e864892a = ({ url: originalUrl, width: width, height: height, format: format })=>{
    const url = (0, $44972171fb249819$export$1758be3e5622c165)(originalUrl);
    if (width && width > 4000) {
        if (height) height = Math.round(height * 4000 / width);
        width = 4000;
    }
    if (height && height > 4000) {
        if (width) width = Math.round(width * 4000 / height);
        height = 4000;
    }
    (0, $44972171fb249819$export$b3ce47f2ef28a28)(url, "w", width, true, true);
    (0, $44972171fb249819$export$b3ce47f2ef28a28)(url, "h", height, true, true);
    (0, $44972171fb249819$export$b3ce47f2ef28a28)(url, "fm", format);
    (0, $44972171fb249819$export$afb2828c24f592c8)(url, "fit", "fill");
    return url;
};



const $f58e2b46bd22cfb6$export$98e6a39c04603d36 = (url)=>{
    const parsedUrl = (0, $44972171fb249819$export$1758be3e5622c165)(url);
    const width = (0, $44972171fb249819$export$d8c59ae245c15523)(parsedUrl, "width");
    const height = (0, $44972171fb249819$export$d8c59ae245c15523)(parsedUrl, "height");
    const quality = (0, $44972171fb249819$export$d8c59ae245c15523)(parsedUrl, "quality");
    const format = parsedUrl.searchParams.get("format") || undefined;
    const fit = parsedUrl.searchParams.get("fit") || undefined;
    parsedUrl.search = "";
    return {
        width: width,
        height: height,
        format: format,
        base: parsedUrl.toString(),
        params: {
            quality: quality,
            fit: fit
        },
        cdn: "builder.io"
    };
};
const $f58e2b46bd22cfb6$export$51186ad6e864892a = ({ url: originalUrl, width: width, height: height, format: format })=>{
    const url = (0, $44972171fb249819$export$1758be3e5622c165)(originalUrl);
    (0, $44972171fb249819$export$b3ce47f2ef28a28)(url, "width", width, true, true);
    (0, $44972171fb249819$export$b3ce47f2ef28a28)(url, "height", height, true, true);
    (0, $44972171fb249819$export$b3ce47f2ef28a28)(url, "format", format);
    if (width && height) {
        (0, $44972171fb249819$export$afb2828c24f592c8)(url, "fit", "cover");
        (0, $44972171fb249819$export$afb2828c24f592c8)(url, "sharp", "true");
    }
    return url;
};



const $0d8431c0744288d8$export$98e6a39c04603d36 = (url)=>{
    const parsed = (0, $44972171fb249819$export$1758be3e5622c165)(url);
    const width = Number(parsed.searchParams.get("w")) || undefined;
    const height = Number(parsed.searchParams.get("h")) || undefined;
    const quality = Number(parsed.searchParams.get("q")) || undefined;
    const format = parsed.searchParams.get("fm") || undefined;
    const params = {};
    parsed.searchParams.forEach((value, key)=>{
        params[key] = value;
    });
    parsed.search = "";
    return {
        base: parsed.toString(),
        width: width,
        height: height,
        quality: quality,
        format: format,
        params: params,
        cdn: "imgix"
    };
};
const $0d8431c0744288d8$export$51186ad6e864892a = ({ url: originalUrl, width: width, height: height, format: format })=>{
    const url = (0, $44972171fb249819$export$1758be3e5622c165)(originalUrl);
    (0, $44972171fb249819$export$b3ce47f2ef28a28)(url, "w", width, true, true);
    (0, $44972171fb249819$export$b3ce47f2ef28a28)(url, "h", height, true, true);
    (0, $44972171fb249819$export$afb2828c24f592c8)(url, "fit", "min");
    if (format) {
        url.searchParams.set("fm", format);
        const fm = url.searchParams.get("auto");
        if (fm === "format") url.searchParams.delete("auto");
        else if (fm === null || fm === void 0 ? void 0 : fm.includes("format")) url.searchParams.set("auto", fm.split(",").filter((s)=>s !== "format").join(","));
    } else {
        var _url_searchParams_get;
        url.searchParams.delete("fm");
        if (!((_url_searchParams_get = url.searchParams.get("auto")) === null || _url_searchParams_get === void 0 ? void 0 : _url_searchParams_get.includes("format"))) url.searchParams.append("auto", "format");
    }
    return url;
};





const $b4a6e4273b42d3fe$var$shopifyRegex = /(.+?)(?:_(?:(pico|icon|thumb|small|compact|medium|large|grande|original|master)|(\d*)x(\d*)))?(?:_crop_([a-z]+))?(\.[a-zA-Z]+)(\.png|\.jpg|\.webp|\.avif)?$/;
const $b4a6e4273b42d3fe$export$98e6a39c04603d36 = (imageUrl)=>{
    const url = (0, $44972171fb249819$export$1758be3e5622c165)(imageUrl);
    const match = url.pathname.match($b4a6e4273b42d3fe$var$shopifyRegex);
    if (!match) throw new Error("Invalid Shopify URL");
    const [, path, size, width, height, crop, extension, format] = match;
    url.pathname = `${path}${extension}`;
    const widthString = width ? width : url.searchParams.get("width");
    const heightString = height ? height : url.searchParams.get("height");
    url.searchParams.delete("width");
    url.searchParams.delete("height");
    return {
        base: url.toString(),
        width: Number(widthString) || undefined,
        height: Number(heightString) || undefined,
        format: format ? format.slice(1) : undefined,
        params: {
            crop: crop,
            size: size
        },
        cdn: "shopify"
    };
};
const $b4a6e4273b42d3fe$export$80d376111cc09ad7 = ({ base: base, width: width, height: height, format: format, params: params })=>{
    const url = (0, $44972171fb249819$export$1758be3e5622c165)(base);
    (0, $44972171fb249819$export$b3ce47f2ef28a28)(url, "width", width, true, true);
    (0, $44972171fb249819$export$b3ce47f2ef28a28)(url, "height", height, true, true);
    (0, $44972171fb249819$export$b3ce47f2ef28a28)(url, "crop", params === null || params === void 0 ? void 0 : params.crop);
    (0, $44972171fb249819$export$b3ce47f2ef28a28)(url, "format", format);
    return url;
};
const $b4a6e4273b42d3fe$export$51186ad6e864892a = ({ url: originalUrl, width: width, height: height })=>{
    const parsed = $b4a6e4273b42d3fe$export$98e6a39c04603d36(originalUrl);
    if (!parsed) return;
    const props = (0, $a6ebb6f5eece5690$export$4fa2f4023c9cbda5)((0, $429981144fb29922$export$581ff339ea0ba762)({}, parsed), {
        width: width,
        height: height
    });
    return $b4a6e4273b42d3fe$export$80d376111cc09ad7(props);
};



const $48e377cbc1615ca8$export$51186ad6e864892a = ({ url: originalUrl, width: width, height: height })=>{
    const url = (0, $44972171fb249819$export$1758be3e5622c165)(originalUrl);
    (0, $44972171fb249819$export$b3ce47f2ef28a28)(url, "w", width, true, true);
    (0, $44972171fb249819$export$b3ce47f2ef28a28)(url, "h", height, true, true);
    (0, $44972171fb249819$export$afb2828c24f592c8)(url, "crop", "1");
    return url;
};
const $48e377cbc1615ca8$export$98e6a39c04603d36 = (url)=>{
    const parsed = (0, $44972171fb249819$export$1758be3e5622c165)(url);
    const width = (0, $44972171fb249819$export$d8c59ae245c15523)(parsed, "w");
    const height = (0, $44972171fb249819$export$d8c59ae245c15523)(parsed, "h");
    const crop = parsed.searchParams.get("crop") === "1";
    parsed.search = "";
    return {
        base: parsed.toString(),
        width: width,
        height: height,
        params: {
            crop: crop
        },
        cdn: "wordpress"
    };
};



const $792d1e5bc93e10c8$export$98e6a39c04603d36 = (url)=>{
    const parsedUrl = (0, $44972171fb249819$export$1758be3e5622c165)(url);
    const width = (0, $44972171fb249819$export$d8c59ae245c15523)(parsedUrl, "w") || undefined;
    const height = (0, $44972171fb249819$export$d8c59ae245c15523)(parsedUrl, "h") || undefined;
    const quality = (0, $44972171fb249819$export$d8c59ae245c15523)(parsedUrl, "q") || undefined;
    parsedUrl.search = "";
    return {
        width: width,
        height: height,
        base: parsedUrl.toString(),
        params: {
            quality: quality
        },
        cdn: "cloudimage"
    };
};
const $792d1e5bc93e10c8$export$51186ad6e864892a = ({ url: originalUrl, width: width, height: height })=>{
    const url = (0, $44972171fb249819$export$1758be3e5622c165)(originalUrl);
    (0, $44972171fb249819$export$b3ce47f2ef28a28)(url, "w", width, true, true);
    (0, $44972171fb249819$export$b3ce47f2ef28a28)(url, "h", height, true, true);
    (0, $44972171fb249819$export$b3ce47f2ef28a28)(url, "q", (0, $44972171fb249819$export$d8c59ae245c15523)(url, "q"), true);
    return url;
};






// Thanks Colby!
const $2572c1614382eadf$var$cloudinaryRegex = RegExp("https?:\\/\\/(?<host>[^\\/]+)\\/(?<cloudName>[^\\/]+)\\/(?<assetType>image|video|raw)\\/(?<deliveryType>upload|fetch|private|authenticated|sprite|facebook|twitter|youtube|vimeo)\\/?(?<signature>s\\-\\-[a-zA-Z0-9]+\\-\\-)?\\/?(?<transformations>(?:[^_\\/]+_[^,\\/]+,?)*)?\\/(?:(?<version>v\\d+)\\/)?(?<idAndFormat>[^\\s]+)$", "g");
const $2572c1614382eadf$var$parseTransforms = (transformations)=>{
    return transformations ? Object.fromEntries(transformations.split(",").map((t)=>t.split("_"))) : {};
};
const $2572c1614382eadf$var$formatUrl = ({ host: host, cloudName: cloudName, assetType: assetType, deliveryType: deliveryType, signature: signature, transformations: transformations = {}, version: version, id: id, format: format })=>{
    if (format) transformations.f = format;
    const transformString = Object.entries(transformations).map(([key, value])=>`${key}_${value}`).join(",");
    const pathSegments = [
        host,
        cloudName,
        assetType,
        deliveryType,
        signature,
        transformString,
        version,
        id
    ].filter(Boolean).join("/");
    return `https://${pathSegments}`;
};
const $2572c1614382eadf$export$98e6a39c04603d36 = (imageUrl)=>{
    const url = (0, $44972171fb249819$export$1758be3e5622c165)(imageUrl);
    const matches = [
        ...url.toString().matchAll($2572c1614382eadf$var$cloudinaryRegex)
    ];
    if (!matches.length) throw new Error("Invalid Cloudinary URL");
    const group = matches[0].groups || {};
    const { transformations: transformString = "", idAndFormat: idAndFormat } = group, baseParams = (0, $97429791653469d6$export$69fdd232f62cde60)(group, [
        "transformations",
        "idAndFormat"
    ]);
    delete group.idAndFormat;
    const lastDotIndex = idAndFormat.lastIndexOf(".");
    const id = lastDotIndex < 0 ? idAndFormat : idAndFormat.slice(0, lastDotIndex);
    const originalFormat = lastDotIndex < 0 ? undefined : idAndFormat.slice(lastDotIndex + 1);
    const _parseTransforms = $2572c1614382eadf$var$parseTransforms(transformString), { w: w, h: h, f: f } = _parseTransforms, transformations = (0, $97429791653469d6$export$69fdd232f62cde60)(_parseTransforms, [
        "w",
        "h",
        "f"
    ]);
    const format = f && f !== "auto" ? f : originalFormat;
    const base = $2572c1614382eadf$var$formatUrl((0, $a6ebb6f5eece5690$export$4fa2f4023c9cbda5)((0, $429981144fb29922$export$581ff339ea0ba762)({}, baseParams), {
        id: id,
        transformations: transformations
    }));
    return {
        base: base,
        width: Number(w) || undefined,
        height: Number(h) || undefined,
        format: format,
        cdn: "cloudinary",
        params: (0, $a6ebb6f5eece5690$export$4fa2f4023c9cbda5)((0, $429981144fb29922$export$581ff339ea0ba762)({}, group), {
            id: group.deliveryType === "fetch" ? idAndFormat : id,
            format: format,
            transformations: transformations
        })
    };
};
const $2572c1614382eadf$export$80d376111cc09ad7 = ({ base: base, width: width, height: height, format: format, params: params })=>{
    var // Default crop to fill without upscaling
    _props_transformations;
    const parsed = $2572c1614382eadf$export$98e6a39c04603d36(base.toString());
    const props = (0, $a6ebb6f5eece5690$export$4fa2f4023c9cbda5)((0, $429981144fb29922$export$581ff339ea0ba762)({
        transformations: {}
    }, parsed.params, params), {
        format: format || "auto"
    });
    if (width) props.transformations.w = (0, $44972171fb249819$export$633dc235a7124180)(width).toString();
    if (height) props.transformations.h = (0, $44972171fb249819$export$633dc235a7124180)(height).toString();
    (_props_transformations = props.transformations).c || (_props_transformations.c = "lfill");
    return $2572c1614382eadf$var$formatUrl(props);
};
const $2572c1614382eadf$export$51186ad6e864892a = ({ url: originalUrl, width: width, height: height, format: format = "auto" })=>{
    var _parsed_params, _parsed_params1;
    const parsed = $2572c1614382eadf$export$98e6a39c04603d36(originalUrl);
    if (!parsed) throw new Error("Invalid Cloudinary URL");
    if (((_parsed_params = parsed.params) === null || _parsed_params === void 0 ? void 0 : _parsed_params.assetType) !== "image") throw new Error("Cloudinary transformer only supports images");
    if ((_parsed_params1 = parsed.params) === null || _parsed_params1 === void 0 ? void 0 : _parsed_params1.signature) throw new Error("Cloudinary transformer does not support signed URLs");
    const props = (0, $a6ebb6f5eece5690$export$4fa2f4023c9cbda5)((0, $429981144fb29922$export$581ff339ea0ba762)({}, parsed), {
        width: width,
        height: height,
        format: format
    });
    return $2572c1614382eadf$export$80d376111cc09ad7(props);
};






const $81bd871b8f1f0a0e$var$cloudflareRegex = RegExp("https?:\\/\\/(?<host>[^\\/]+)\\/cdn-cgi\\/image\\/(?<transformations>[^\\/]+)?\\/(?<path>.*)$", "g");
const $81bd871b8f1f0a0e$var$parseTransforms = (transformations)=>Object.fromEntries(transformations.split(",").map((t)=>t.split("=")));
const $81bd871b8f1f0a0e$var$formatUrl = ({ host: host, transformations: transformations = {}, path: path })=>{
    const transformString = Object.entries(transformations).map(([key, value])=>`${key}=${value}`).join(",");
    const pathSegments = [
        host,
        "cdn-cgi",
        "image",
        transformString,
        path
    ].join("/");
    return `https://${pathSegments}`;
};
const $81bd871b8f1f0a0e$export$98e6a39c04603d36 = (imageUrl)=>{
    const url = (0, $44972171fb249819$export$1758be3e5622c165)(imageUrl);
    const matches = [
        ...url.toString().matchAll($81bd871b8f1f0a0e$var$cloudflareRegex)
    ];
    if (!matches.length) throw new Error("Invalid Cloudflare URL");
    const group = matches[0].groups || {};
    const { transformations: transformString } = group, baseParams = (0, $97429791653469d6$export$69fdd232f62cde60)(group, [
        "transformations"
    ]);
    const _parseTransforms = $81bd871b8f1f0a0e$var$parseTransforms(transformString), { width: width, height: height, f: f } = _parseTransforms, transformations = (0, $97429791653469d6$export$69fdd232f62cde60)(_parseTransforms, [
        "width",
        "height",
        "f"
    ]);
    const base = $81bd871b8f1f0a0e$var$formatUrl((0, $a6ebb6f5eece5690$export$4fa2f4023c9cbda5)((0, $429981144fb29922$export$581ff339ea0ba762)({}, baseParams), {
        transformations: transformations
    }));
    return {
        base: url.toString(),
        width: Number(width) || undefined,
        height: Number(height) || undefined,
        format: f,
        cdn: "cloudflare",
        params: (0, $a6ebb6f5eece5690$export$4fa2f4023c9cbda5)((0, $429981144fb29922$export$581ff339ea0ba762)({}, group), {
            transformations: transformations
        })
    };
};
const $81bd871b8f1f0a0e$export$80d376111cc09ad7 = ({ base: base, width: width, height: height, format: format, params: params })=>{
    var _props_transformations;
    const parsed = $81bd871b8f1f0a0e$export$98e6a39c04603d36(base.toString());
    const props = (0, $429981144fb29922$export$581ff339ea0ba762)({
        transformations: {}
    }, parsed.params, params);
    if (width) props.transformations.width = width === null || width === void 0 ? void 0 : width.toString();
    if (height) props.transformations.height = height === null || height === void 0 ? void 0 : height.toString();
    if (format) props.transformations.f = format === "jpg" ? "jpeg" : format;
    (_props_transformations = props.transformations).fit || (_props_transformations.fit = "cover");
    return new URL($81bd871b8f1f0a0e$var$formatUrl(props));
};
const $81bd871b8f1f0a0e$export$51186ad6e864892a = ({ url: originalUrl, width: width, height: height, format: format = "auto" })=>{
    const parsed = $81bd871b8f1f0a0e$export$98e6a39c04603d36(originalUrl);
    if (!parsed) throw new Error("Invalid Cloudflare URL");
    const props = (0, $a6ebb6f5eece5690$export$4fa2f4023c9cbda5)((0, $429981144fb29922$export$581ff339ea0ba762)({}, parsed), {
        width: width,
        height: height,
        format: format
    });
    return $81bd871b8f1f0a0e$export$80d376111cc09ad7(props);
};



const $af07e4e9c9a96ab6$export$98e6a39c04603d36 = (url)=>{
    const parsedUrl = (0, $44972171fb249819$export$1758be3e5622c165)(url);
    const width = (0, $44972171fb249819$export$d8c59ae245c15523)(parsedUrl, "width");
    const height = (0, $44972171fb249819$export$d8c59ae245c15523)(parsedUrl, "height");
    const params = {};
    parsedUrl.searchParams.forEach((value, key)=>{
        params[key] = value;
    });
    parsedUrl.search = "";
    return {
        width: width,
        height: height,
        base: parsedUrl.toString(),
        params: params,
        cdn: "bunny"
    };
};
const $af07e4e9c9a96ab6$export$51186ad6e864892a = ({ url: originalUrl, width: width, height: height })=>{
    const url = (0, $44972171fb249819$export$1758be3e5622c165)(originalUrl);
    (0, $44972171fb249819$export$b3ce47f2ef28a28)(url, "width", width, true, true);
    if (width && height) (0, $44972171fb249819$export$afb2828c24f592c8)(url, "aspect_ratio", `${width}:${height}`);
    return url;
};






const $28152f210342af02$var$storyBlokAssets = RegExp("(?<id>\\/f\\/\\d+\\/\\d+x\\d+\\/\\w+\\/[^\\/]+)\\/?(?<modifiers>m\\/?(?<crop>\\d+x\\d+:\\d+x\\d+)?\\/?(?<resize>(?<flipx>\\-)?(?<width>\\d+)x(?<flipy>\\-)?(?<height>\\d+))?\\/?(filters\\:(?<filters>[^\\/]+))?)?$", "g");
const $28152f210342af02$var$storyBlokImg2 = RegExp("^(?<modifiers>\\/(?<crop>\\d+x\\d+:\\d+x\\d+)?\\/?(?<resize>(?<flipx>\\-)?(?<width>\\d+)x(?<flipy>\\-)?(?<height>\\d+))?\\/?(filters\\:(?<filters>[^\\/]+))?\\/?)?(?<id>\\/f\\/.+)$", "g");
const $28152f210342af02$export$769dddb4108bfaf6 = (filters)=>{
    if (!filters) return {};
    return Object.fromEntries(filters.split(":").map((filter)=>{
        if (!filter) return [];
        const [key, value] = filter.split("(");
        return [
            key,
            value.replace(")", "")
        ];
    }));
};
const $28152f210342af02$export$12a8b4f769a4cd32 = (filters)=>{
    if (!filters) return undefined;
    const filterItems = Object.entries(filters).map(([key, value])=>`${key}(${value !== null && value !== void 0 ? value : ""})`);
    if (filterItems.length === 0) return undefined;
    return `filters:${filterItems.join(":")}`;
};
const $28152f210342af02$export$98e6a39c04603d36 = (imageUrl)=>{
    const url = (0, $44972171fb249819$export$1758be3e5622c165)(imageUrl);
    // img2.storyblok.com is the old domain for Storyblok images, which used a
    // different path format. We'll assume custom domains are using the new format.
    const regex = url.hostname === "img2.storyblok.com" ? $28152f210342af02$var$storyBlokImg2 : $28152f210342af02$var$storyBlokAssets;
    const [matches] = url.pathname.matchAll(regex);
    if (!matches || !matches.groups) throw new Error("Invalid Storyblok URL");
    const { id: id, crop: crop, width: width, height: height, filters: filters, flipx: flipx, flipy: flipy } = matches.groups;
    const _splitFilters = $28152f210342af02$export$769dddb4108bfaf6(filters), { format: format } = _splitFilters, filterMap = (0, $97429791653469d6$export$69fdd232f62cde60)(_splitFilters, [
        "format"
    ]);
    // We update old img2.storyblok.com URLs to use the new syntax and domain
    if (url.hostname === "img2.storyblok.com") url.hostname = "a.storyblok.com";
    return {
        base: url.origin + id,
        width: Number(width) || undefined,
        height: Number(height) || undefined,
        format: format,
        params: {
            crop: crop,
            filters: filterMap,
            flipx: flipx,
            flipy: flipy
        },
        cdn: "storyblok"
    };
};
const $28152f210342af02$export$80d376111cc09ad7 = ({ base: base, width: width = 0, height: height = 0, format: format, params: params = {} })=>{
    const { crop: crop, filters: filters, flipx: flipx = "", flipy: flipy = "" } = params;
    const size = `${flipx}${width}x${flipy}${height}`;
    return new URL([
        base,
        "m",
        crop,
        size,
        $28152f210342af02$export$12a8b4f769a4cd32(filters),
        format
    ].filter(Boolean).join("/"));
};
const $28152f210342af02$export$51186ad6e864892a = ({ url: originalUrl, width: width, height: height, format: format })=>{
    const parsed = $28152f210342af02$export$98e6a39c04603d36(originalUrl);
    if (!parsed) return;
    if (format) {
        if (!parsed.params) parsed.params = {
            filters: {}
        };
        if (!parsed.params.filters) parsed.params.filters = {};
        parsed.params.filters.format = format;
    }
    return $28152f210342af02$export$80d376111cc09ad7((0, $a6ebb6f5eece5690$export$4fa2f4023c9cbda5)((0, $429981144fb29922$export$581ff339ea0ba762)({}, parsed), {
        width: width,
        height: height
    }));
};



const $a69549a44906e25e$export$98e6a39c04603d36 = (url)=>{
    const parsedUrl = (0, $44972171fb249819$export$1758be3e5622c165)(url);
    const fit = parsedUrl.searchParams.get("fit") || undefined;
    const width = (0, $44972171fb249819$export$d8c59ae245c15523)(parsedUrl, "w");
    const height = (0, $44972171fb249819$export$d8c59ae245c15523)(parsedUrl, "h");
    const quality = (0, $44972171fb249819$export$d8c59ae245c15523)(parsedUrl, "q");
    const format = parsedUrl.searchParams.get("fm") || undefined;
    parsedUrl.search = "";
    return {
        width: width,
        height: height,
        format: format,
        base: parsedUrl.toString(),
        params: {
            fit: fit,
            quality: quality
        },
        cdn: "kontent.ai"
    };
};
const $a69549a44906e25e$export$51186ad6e864892a = ({ url: originalUrl, width: width, height: height, format: format })=>{
    const url = (0, $44972171fb249819$export$1758be3e5622c165)(originalUrl);
    (0, $44972171fb249819$export$b3ce47f2ef28a28)(url, "w", width, true, true);
    (0, $44972171fb249819$export$b3ce47f2ef28a28)(url, "h", height, true, true);
    (0, $44972171fb249819$export$b3ce47f2ef28a28)(url, "fm", format, true);
    if (width && height) (0, $44972171fb249819$export$afb2828c24f592c8)(url, "fit", "crop");
    return url;
};




const $0423897cdb6b7664$export$98e6a39c04603d36 = (url)=>{
    const parsed = (0, $44972171fb249819$export$1758be3e5622c165)(url);
    const width = Number(parsed.searchParams.get("w")) || undefined;
    const quality = Number(parsed.searchParams.get("q")) || undefined;
    return {
        base: parsed.toString(),
        width: width,
        quality: quality,
        cdn: "vercel"
    };
};
const $0423897cdb6b7664$export$eab35c9036dd66d1 = (url)=>{
    const parsed = (0, $44972171fb249819$export$1758be3e5622c165)(url);
    const source = parsed.searchParams.get("url");
    if (!source || !source.startsWith("http")) return false;
    const cdn = (0, $697dc7106d3c3089$export$2192df6ac6dfdd0b)(source);
    if (!cdn) return false;
    return {
        cdn: cdn,
        url: source
    };
};
const $0423897cdb6b7664$export$80d376111cc09ad7 = ({ base: base, width: width, params: { quality: quality = 75, root: root = "_vercel" } = {} })=>{
    // If the base is a relative URL, we need to add a dummy host to the URL
    const url = new URL("http://n");
    url.pathname = `/${root}/image`;
    url.searchParams.set("url", base.toString());
    (0, $44972171fb249819$export$b3ce47f2ef28a28)(url, "w", width, false, true);
    (0, $44972171fb249819$export$afb2828c24f592c8)(url, "q", quality);
    return (0, $44972171fb249819$export$4ebdca5513a016fe)(url);
};
const $0423897cdb6b7664$export$51186ad6e864892a = ({ url: url, width: width, cdn: cdn })=>{
    // the URL might be relative, so we need to add a dummy host to it
    const parsedUrl = (0, $44972171fb249819$export$1758be3e5622c165)(url);
    const isNextImage = parsedUrl.pathname.startsWith("/_next/image") || parsedUrl.pathname.startsWith("/_vercel/image");
    const src = isNextImage ? parsedUrl.searchParams.get("url") : url.toString();
    if (!src) return undefined;
    (0, $44972171fb249819$export$b3ce47f2ef28a28)(parsedUrl, "w", width, true, true);
    if (isNextImage) return (0, $44972171fb249819$export$9a5ff27ac96579c6)(parsedUrl);
    return $0423897cdb6b7664$export$80d376111cc09ad7({
        base: src,
        width: width,
        params: {
            root: cdn === "nextjs" ? "_next" : "_vercel"
        }
    });
};





const $206aac1cc04ad0bc$export$98e6a39c04603d36 = (url)=>(0, $a6ebb6f5eece5690$export$4fa2f4023c9cbda5)((0, $429981144fb29922$export$581ff339ea0ba762)({}, (0, $0423897cdb6b7664$export$98e6a39c04603d36)(url)), {
        cdn: "nextjs"
    });
const $206aac1cc04ad0bc$export$51186ad6e864892a = (params)=>(0, $0423897cdb6b7664$export$51186ad6e864892a)((0, $a6ebb6f5eece5690$export$4fa2f4023c9cbda5)((0, $429981144fb29922$export$581ff339ea0ba762)({}, params), {
        cdn: "nextjs"
    }));



const $ca8867de4c2828ec$export$98e6a39c04603d36 = (url)=>{
    const parsedUrl = (0, $44972171fb249819$export$1758be3e5622c165)(url);
    const fit = parsedUrl.searchParams.get("fit") || undefined;
    const width = (0, $44972171fb249819$export$d8c59ae245c15523)(parsedUrl, "wid");
    const height = (0, $44972171fb249819$export$d8c59ae245c15523)(parsedUrl, "hei");
    const quality = (0, $44972171fb249819$export$d8c59ae245c15523)(parsedUrl, "qlt") || undefined;
    const format = parsedUrl.searchParams.get("fmt") || undefined;
    const scale = (0, $44972171fb249819$export$d8c59ae245c15523)(parsedUrl, "scl") || undefined;
    return {
        width: width,
        height: height,
        format: format,
        base: parsedUrl.toString(),
        params: {
            fit: fit,
            quality: quality,
            scale: scale
        },
        cdn: "scene7"
    };
};
const $ca8867de4c2828ec$export$51186ad6e864892a = ({ url: originalUrl, width: width, height: height, format: format })=>{
    const url = (0, $44972171fb249819$export$1758be3e5622c165)(originalUrl);
    (0, $44972171fb249819$export$b3ce47f2ef28a28)(url, "wid", width, true, true);
    (0, $44972171fb249819$export$b3ce47f2ef28a28)(url, "hei", height, true, true);
    (0, $44972171fb249819$export$b3ce47f2ef28a28)(url, "fmt", format, true);
    (0, $44972171fb249819$export$b3ce47f2ef28a28)(url, "qlt", (0, $44972171fb249819$export$d8c59ae245c15523)(url, "qlt"), true);
    (0, $44972171fb249819$export$b3ce47f2ef28a28)(url, "scl", (0, $44972171fb249819$export$d8c59ae245c15523)(url, "scl"), true);
    (0, $44972171fb249819$export$afb2828c24f592c8)(url, "fit", "crop");
    if (!width && !height) (0, $44972171fb249819$export$afb2828c24f592c8)(url, "scl", 1);
    return url;
};



const $e2a2bbf5dab34cd2$export$98e6a39c04603d36 = (url)=>{
    const parsedUrl = (0, $44972171fb249819$export$1758be3e5622c165)(url);
    const width = (0, $44972171fb249819$export$d8c59ae245c15523)(parsedUrl, "width");
    const height = (0, $44972171fb249819$export$d8c59ae245c15523)(parsedUrl, "height");
    const format = parsedUrl.searchParams.get("format") || undefined;
    const quality = (0, $44972171fb249819$export$d8c59ae245c15523)(parsedUrl, "quality") || undefined;
    return {
        width: width,
        height: height,
        format: format,
        base: parsedUrl.toString(),
        params: {
            quality: quality
        },
        cdn: "keycdn"
    };
};
const $e2a2bbf5dab34cd2$export$51186ad6e864892a = ({ url: originalUrl, width: width, height: height, format: format })=>{
    const url = (0, $44972171fb249819$export$1758be3e5622c165)(originalUrl);
    (0, $44972171fb249819$export$b3ce47f2ef28a28)(url, "width", width, true, true);
    (0, $44972171fb249819$export$b3ce47f2ef28a28)(url, "height", height, true, true);
    (0, $44972171fb249819$export$b3ce47f2ef28a28)(url, "format", format, true);
    (0, $44972171fb249819$export$b3ce47f2ef28a28)(url, "quality", (0, $44972171fb249819$export$d8c59ae245c15523)(url, "quality"), true);
    (0, $44972171fb249819$export$afb2828c24f592c8)(url, "enlarge", 0);
    return url;
};



const $e50f1c04065502cf$export$98e6a39c04603d36 = (imageUrl)=>{
    const parsedUrl = (0, $44972171fb249819$export$1758be3e5622c165)(imageUrl);
    const width = (0, $44972171fb249819$export$d8c59ae245c15523)(parsedUrl, "width");
    const height = (0, $44972171fb249819$export$d8c59ae245c15523)(parsedUrl, "height");
    const format = parsedUrl.searchParams.get("format") || undefined;
    const quality = (0, $44972171fb249819$export$d8c59ae245c15523)(parsedUrl, "quality") || undefined;
    let fit = parsedUrl.searchParams.get("fit") || undefined;
    const withoutEnlargement = parsedUrl.searchParams.get("withoutEnlargement") === "true" || undefined;
    const transforms = parsedUrl.searchParams.get("transforms") || undefined;
    // if fit doesn't satisfy the type, it will be undefined
    if (fit && ![
        "cover",
        "contain",
        "inside",
        "outside"
    ].includes(fit)) fit = undefined;
    return {
        width: width,
        height: height,
        format: format,
        base: parsedUrl.toString(),
        params: {
            fit: fit,
            quality: quality,
            withoutEnlargement: withoutEnlargement,
            transforms: transforms ? JSON.parse(transforms) : undefined
        },
        cdn: "directus"
    };
};
const $e50f1c04065502cf$export$51186ad6e864892a = ({ url: originalUrl, width: width, height: height, format: format })=>{
    const url = (0, $44972171fb249819$export$1758be3e5622c165)(originalUrl);
    (0, $44972171fb249819$export$b3ce47f2ef28a28)(url, "width", width, true, true);
    (0, $44972171fb249819$export$b3ce47f2ef28a28)(url, "height", height, true, true);
    (0, $44972171fb249819$export$b3ce47f2ef28a28)(url, "format", format);
    (0, $44972171fb249819$export$b3ce47f2ef28a28)(url, "quality", (0, $44972171fb249819$export$d8c59ae245c15523)(url, "quality"), true);
    return url;
};





const $33fe6d6ca9d1fc85$export$2ec9139d09cec4d6 = {
    width: "w",
    height: "h",
    autoWidthWithFallback: "w_auto",
    auto_width_fallback: "w_auto",
    scaleToScreenWidth: "pc",
    scale_to_screen_width: "pc",
    crop: "cr",
    outputFormat: "f",
    format: "f",
    fit: "m",
    fitMethod: "m",
    compression: "cmpr",
    sharpness: "s",
    rotate: "r",
    inline: "in",
    keepMeta: "meta",
    keep_meta: "meta",
    noOptimization: "pass",
    no_optimization: "pass",
    force_download: "dl",
    max_device_pixel_ratio: "maxdpr",
    maxDevicePixelRatio: "maxdpr"
};
const $33fe6d6ca9d1fc85$export$98e6a39c04603d36 = (imageUrl)=>{
    const parsedUrl = (0, $44972171fb249819$export$1758be3e5622c165)(imageUrl);
    const paramArray = $33fe6d6ca9d1fc85$export$108f4fc42d7245c7(parsedUrl);
    const baseUrl = $33fe6d6ca9d1fc85$export$f654b28f82155665(parsedUrl);
    let width = undefined, height = undefined, format = undefined;
    const params = {};
    if (paramArray.length > 0) paramArray.forEach((para)=>{
        let key_value = para.split("_");
        if (key_value.length > 1) switch(key_value[0]){
            case "w":
                width = Number(key_value[1]);
                break;
            case "h":
                height = Number(key_value[1]);
                break;
            case "f":
                format = key_value[1];
                break;
            default:
                if (Object.values($33fe6d6ca9d1fc85$export$2ec9139d09cec4d6).includes(key_value[0])) {
                    let directive = $33fe6d6ca9d1fc85$export$86fab5695691c3b3(key_value[0]);
                    params[directive] = key_value[1];
                }
        }
    });
    return {
        base: baseUrl,
        width: width,
        height: height,
        format: format,
        params: params,
        cdn: "imageengine"
    };
};
function $33fe6d6ca9d1fc85$export$86fab5695691c3b3(key) {
    let keyArray = Object.keys($33fe6d6ca9d1fc85$export$2ec9139d09cec4d6);
    let directive = keyArray.find((k)=>$33fe6d6ca9d1fc85$export$2ec9139d09cec4d6[k] === key) || "";
    return directive;
}
function $33fe6d6ca9d1fc85$export$108f4fc42d7245c7(url) {
    let url_string = url.toString();
    let paramArray = [];
    if (url_string) {
        let splitURL = url_string.split("imgeng=");
        if (splitURL.length > 1) paramArray = splitURL[1].split("/");
    }
    return paramArray;
}
function $33fe6d6ca9d1fc85$export$f654b28f82155665(url) {
    let url_string = url.toString();
    let baseUrl = "";
    if (url_string) {
        let splitURL = url_string.split("imgeng=");
        if (splitURL.length > 1) baseUrl = splitURL[0].slice(0, -1);
        else baseUrl = url_string;
    }
    return baseUrl;
}
const $33fe6d6ca9d1fc85$export$51186ad6e864892a = ({ url: originalUrl, width: width, height: height, format: format })=>{
    const url = (0, $44972171fb249819$export$1758be3e5622c165)(originalUrl);
    const src = $33fe6d6ca9d1fc85$export$f654b28f82155665(url);
    let directives = {};
    const param = url.toString() === src ? [] : $33fe6d6ca9d1fc85$export$108f4fc42d7245c7(url);
    if (param.length) directives = $33fe6d6ca9d1fc85$export$a06695571bfb612b(param);
    if (width) directives["width"] = width;
    if (height) directives["height"] = height;
    if (format) directives["format"] = format;
    if (!directives.hasOwnProperty("fit")) directives = (0, $a6ebb6f5eece5690$export$4fa2f4023c9cbda5)((0, $429981144fb29922$export$581ff339ea0ba762)({}, directives), {
        "fit": "cropbox"
    });
    let directives_string = $33fe6d6ca9d1fc85$export$9da918dd1720b6a7(directives);
    let query_string = $33fe6d6ca9d1fc85$export$934bc4aedb665015(directives_string);
    let query_prefix = query_string === "" ? "" : src.includes("?") ? "&" : "?";
    return `${src}${query_prefix}${query_string}`;
};
function $33fe6d6ca9d1fc85$export$9da918dd1720b6a7(directives) {
    return Object.entries(directives).reduce((acc, [k, v])=>{
        return acc + $33fe6d6ca9d1fc85$export$cbb2ce2a507a6126(k, v);
    }, "");
}
function $33fe6d6ca9d1fc85$export$934bc4aedb665015(directives_string) {
    if (directives_string && directives_string !== "") return `imgeng=${directives_string}`;
    return "";
}
function $33fe6d6ca9d1fc85$export$cbb2ce2a507a6126(directive, value) {
    let translated_directive = $33fe6d6ca9d1fc85$export$2ec9139d09cec4d6[directive];
    if (translated_directive && (value || value === 0)) return `/${translated_directive}_${value}`;
    return "";
}
function $33fe6d6ca9d1fc85$export$a06695571bfb612b(paramArray) {
    let directives = {};
    paramArray.forEach((para)=>{
        let keyValue = para.split("_");
        if (keyValue.length > 1) {
            let key = keyValue[0];
            let value = keyValue[1];
            let directiveKey = $33fe6d6ca9d1fc85$export$86fab5695691c3b3(key);
            if (directiveKey) directives[directiveKey] = value;
        }
    });
    return directives;
}



const $5b6d484210859047$export$98e6a39c04603d36 = (url)=>{
    const parsedUrl = (0, $44972171fb249819$export$1758be3e5622c165)(url);
    const fit = parsedUrl.searchParams.get("fit") || undefined;
    const width = (0, $44972171fb249819$export$d8c59ae245c15523)(parsedUrl, "width");
    const height = (0, $44972171fb249819$export$d8c59ae245c15523)(parsedUrl, "height");
    const quality = (0, $44972171fb249819$export$d8c59ae245c15523)(parsedUrl, "quality");
    const format = parsedUrl.searchParams.get("format") || undefined;
    parsedUrl.search = "";
    return {
        width: width,
        height: height,
        format: format,
        base: parsedUrl.toString(),
        params: {
            fit: fit,
            quality: quality
        },
        cdn: "contentstack"
    };
};
const $5b6d484210859047$export$51186ad6e864892a = ({ url: originalUrl, width: width, height: height, format: format })=>{
    const url = (0, $44972171fb249819$export$1758be3e5622c165)(originalUrl);
    (0, $44972171fb249819$export$b3ce47f2ef28a28)(url, "width", width, true, true);
    (0, $44972171fb249819$export$b3ce47f2ef28a28)(url, "height", height, true, true);
    (0, $44972171fb249819$export$b3ce47f2ef28a28)(url, "format", format);
    if (!url.searchParams.has("format")) (0, $44972171fb249819$export$afb2828c24f592c8)(url, "auto", "webp");
    if (width && height) (0, $44972171fb249819$export$afb2828c24f592c8)(url, "fit", "crop");
    return url;
};






const $cf4f434e1e8859b7$var$cloudflareImagesRegex = RegExp("https?:\\/\\/(?<host>[^\\/]+)\\/cdn-cgi\\/imagedelivery\\/(?<accountHash>[^\\/]+)\\/(?<imageId>[^\\/]+)\\/*(?<transformations>[^\\/]+)*$", "g");
const $cf4f434e1e8859b7$var$parseTransforms = (transformations)=>{
    var _transformations_split;
    var _transformations_split_map;
    return Object.fromEntries((_transformations_split_map = transformations === null || transformations === void 0 ? void 0 : (_transformations_split = transformations.split(",")) === null || _transformations_split === void 0 ? void 0 : _transformations_split.map((t)=>t.split("="))) !== null && _transformations_split_map !== void 0 ? _transformations_split_map : []);
};
const $cf4f434e1e8859b7$var$formatUrl = ({ host: host, accountHash: accountHash, transformations: transformations = {}, imageId: imageId })=>{
    const transformString = Object.entries(transformations).map(([key, value])=>`${key}=${value}`).join(",");
    const pathSegments = [
        host,
        "cdn-cgi",
        "imagedelivery",
        accountHash,
        imageId,
        transformString
    ].join("/");
    return `https://${pathSegments}`;
};
const $cf4f434e1e8859b7$export$98e6a39c04603d36 = (imageUrl)=>{
    const url = (0, $44972171fb249819$export$1758be3e5622c165)(imageUrl);
    const matches = [
        ...url.toString().matchAll($cf4f434e1e8859b7$var$cloudflareImagesRegex)
    ];
    if (!matches.length) throw new Error("Invalid Cloudflare Images URL");
    const group = matches[0].groups || {};
    const { transformations: transformString } = group, baseParams = (0, $97429791653469d6$export$69fdd232f62cde60)(group, [
        "transformations"
    ]);
    const _parseTransforms = $cf4f434e1e8859b7$var$parseTransforms(transformString), { w: w, h: h, f: f } = _parseTransforms, transformations = (0, $97429791653469d6$export$69fdd232f62cde60)(_parseTransforms, [
        "w",
        "h",
        "f"
    ]);
    return {
        base: url.toString(),
        width: Number(w) || undefined,
        height: Number(h) || undefined,
        format: f,
        cdn: "cloudflare_images",
        params: (0, $a6ebb6f5eece5690$export$4fa2f4023c9cbda5)((0, $429981144fb29922$export$581ff339ea0ba762)({}, baseParams), {
            transformations: transformations
        })
    };
};
const $cf4f434e1e8859b7$export$80d376111cc09ad7 = ({ base: base, width: width, height: height, format: format, params: params })=>{
    var _props_transformations;
    const parsed = $cf4f434e1e8859b7$export$98e6a39c04603d36(base.toString());
    const props = (0, $429981144fb29922$export$581ff339ea0ba762)({
        transformations: {}
    }, parsed.params, params);
    if (width) props.transformations.w = width === null || width === void 0 ? void 0 : width.toString();
    if (height) props.transformations.h = height === null || height === void 0 ? void 0 : height.toString();
    if (format) props.transformations.f = format;
    (_props_transformations = props.transformations).fit || (_props_transformations.fit = "cover");
    return new URL($cf4f434e1e8859b7$var$formatUrl(props));
};
const $cf4f434e1e8859b7$export$51186ad6e864892a = ({ url: originalUrl, width: width, height: height, format: format = "auto" })=>{
    const parsed = $cf4f434e1e8859b7$export$98e6a39c04603d36(originalUrl);
    if (!parsed) throw new Error("Invalid Cloudflare Images URL");
    const props = (0, $a6ebb6f5eece5690$export$4fa2f4023c9cbda5)((0, $429981144fb29922$export$581ff339ea0ba762)({}, parsed), {
        width: width,
        height: height,
        format: format
    });
    return $cf4f434e1e8859b7$export$80d376111cc09ad7(props);
};





const $f0d4015d5362be75$export$98e6a39c04603d36 = (imageUrl)=>{
    const url = (0, $44972171fb249819$export$1758be3e5622c165)(imageUrl);
    const [modifiers, ...id] = url.pathname.split("/").slice(1);
    const params = Object.fromEntries(modifiers.split(",").map((modifier)=>{
        const [key, value] = modifier.split("_");
        return [
            key,
            value
        ];
    }));
    if (params.s) {
        var _params, _params1;
        const [width, height] = params.s.split("x");
        (_params = params).w || (_params.w = width);
        (_params1 = params).h || (_params1.h = height);
    }
    return {
        base: id.join("/"),
        width: Number(params.w) || undefined,
        height: Number(params.h) || undefined,
        quality: Number(params.q) || undefined,
        format: params.f || "auto",
        params: params,
        cdn: "ipx"
    };
};
const $f0d4015d5362be75$export$80d376111cc09ad7 = ({ base: id, width: width, height: height, format: format, params: params })=>{
    var _params_modifiers;
    const modifiers = (_params_modifiers = params === null || params === void 0 ? void 0 : params.modifiers) !== null && _params_modifiers !== void 0 ? _params_modifiers : {};
    if (width && height) modifiers.s = `${width}x${height}`;
    else if (width) modifiers.w = `${width}`;
    else if (height) modifiers.h = `${height}`;
    if (format) modifiers.f = format;
    const base = (params === null || params === void 0 ? void 0 : params.base.endsWith("/")) ? params === null || params === void 0 ? void 0 : params.base : `${params === null || params === void 0 ? void 0 : params.base}/`;
    const modifiersString = Object.entries(modifiers).map(([key, value])=>`${key}_${value}`).join(",");
    const stringId = id.toString();
    const image = stringId.startsWith("/") ? stringId.slice(1) : stringId;
    return `${base}${modifiersString}/${image}`;
};
const $f0d4015d5362be75$export$51186ad6e864892a = (options)=>{
    var _options_cdnOptions_ipx, _options_cdnOptions, _options_cdnOptions1;
    const url = String(options.url);
    const parsedUrl = (0, $44972171fb249819$export$1758be3e5622c165)(url);
    const defaultBase = parsedUrl.pathname.startsWith("/_ipx") && parsedUrl.hostname !== "n" ? `${parsedUrl.origin}/_ipx` : "/_ipx";
    var _options_cdnOptions_ipx_base;
    const base = (_options_cdnOptions_ipx_base = (_options_cdnOptions = options.cdnOptions) === null || _options_cdnOptions === void 0 ? void 0 : (_options_cdnOptions_ipx = _options_cdnOptions.ipx) === null || _options_cdnOptions_ipx === void 0 ? void 0 : _options_cdnOptions_ipx.base) !== null && _options_cdnOptions_ipx_base !== void 0 ? _options_cdnOptions_ipx_base : defaultBase;
    const isIpxUrl = base && base !== "/" && url.startsWith(base);
    if (isIpxUrl) {
        var _options_cdnOptions2;
        const parsed = $f0d4015d5362be75$export$98e6a39c04603d36(url.replace(base, ""));
        return $f0d4015d5362be75$export$80d376111cc09ad7((0, $a6ebb6f5eece5690$export$4fa2f4023c9cbda5)((0, $429981144fb29922$export$581ff339ea0ba762)({}, parsed, options), {
            params: (0, $a6ebb6f5eece5690$export$4fa2f4023c9cbda5)((0, $429981144fb29922$export$581ff339ea0ba762)({}, (_options_cdnOptions2 = options.cdnOptions) === null || _options_cdnOptions2 === void 0 ? void 0 : _options_cdnOptions2.ipx), {
                base: base
            })
        }));
    }
    return $f0d4015d5362be75$export$80d376111cc09ad7((0, $a6ebb6f5eece5690$export$4fa2f4023c9cbda5)((0, $429981144fb29922$export$581ff339ea0ba762)({}, options), {
        base: url,
        params: (0, $a6ebb6f5eece5690$export$4fa2f4023c9cbda5)((0, $429981144fb29922$export$581ff339ea0ba762)({}, (_options_cdnOptions1 = options.cdnOptions) === null || _options_cdnOptions1 === void 0 ? void 0 : _options_cdnOptions1.ipx), {
            base: base
        })
    }));
};




const $f89c0e79ccb90b21$export$eab35c9036dd66d1 = (url)=>{
    const parsedUrl = (0, $44972171fb249819$export$1758be3e5622c165)(url);
    const searchParamHref = parsedUrl.searchParams.get("href");
    const decodedHref = typeof searchParamHref === "string" ? decodeURIComponent(searchParamHref) : new URL(parsedUrl.pathname, parsedUrl.origin).toString();
    const source = (0, $44972171fb249819$export$9a5ff27ac96579c6)((0, $44972171fb249819$export$1758be3e5622c165)(decodedHref));
    if (!source || !source.startsWith("http")) return false;
    const cdn = (0, $697dc7106d3c3089$export$2192df6ac6dfdd0b)(source);
    if (!cdn) return false;
    return {
        cdn: cdn,
        url: source
    };
};
const $f89c0e79ccb90b21$export$98e6a39c04603d36 = (url)=>{
    const parsedUrl = (0, $44972171fb249819$export$1758be3e5622c165)(url);
    const searchParamHref = parsedUrl.searchParams.get("href");
    const decodedHref = typeof searchParamHref === "string" ? decodeURIComponent(searchParamHref) : new URL(parsedUrl.pathname, parsedUrl.origin).toString();
    const encodedHref = encodeURIComponent((0, $44972171fb249819$export$9a5ff27ac96579c6)((0, $44972171fb249819$export$1758be3e5622c165)(decodedHref)));
    const width = (0, $44972171fb249819$export$d8c59ae245c15523)(parsedUrl, "w") || undefined;
    const height = (0, $44972171fb249819$export$d8c59ae245c15523)(parsedUrl, "h") || undefined;
    const format = parsedUrl.searchParams.get("f") || undefined;
    const quality = parsedUrl.searchParams.get("q") || undefined;
    return {
        width: width,
        height: height,
        format: format,
        base: `/_image?href=${encodedHref}`,
        params: {
            quality: quality,
            href: encodedHref
        },
        cdn: "astro"
    };
};
const $f89c0e79ccb90b21$export$51186ad6e864892a = ({ url: originalUrl, width: width, height: height, format: format })=>{
    const parsedUrl = (0, $44972171fb249819$export$1758be3e5622c165)(originalUrl);
    const href = (0, $44972171fb249819$export$9a5ff27ac96579c6)(new URL(parsedUrl.pathname, parsedUrl.origin));
    const url = {
        searchParams: new URLSearchParams()
    };
    (0, $44972171fb249819$export$b3ce47f2ef28a28)(url, "href", href, true, true);
    (0, $44972171fb249819$export$b3ce47f2ef28a28)(url, "w", width, true, true);
    (0, $44972171fb249819$export$b3ce47f2ef28a28)(url, "h", height, true, true);
    (0, $44972171fb249819$export$b3ce47f2ef28a28)(url, "f", format);
    return `/_image?${url.searchParams.toString()}`;
};






const $c44ceeb1a0afd531$var$skippedParams = new Set([
    "w",
    "h",
    "q",
    "fm",
    "url",
    "width",
    "height",
    "quality"
]);
const $c44ceeb1a0afd531$export$98e6a39c04603d36 = (url)=>{
    const parsed = (0, $44972171fb249819$export$1758be3e5622c165)(url);
    var _parsed_searchParams_get, _Number;
    const width = (_Number = Number((_parsed_searchParams_get = parsed.searchParams.get("w")) !== null && _parsed_searchParams_get !== void 0 ? _parsed_searchParams_get : parsed.searchParams.get("width"))) !== null && _Number !== void 0 ? _Number : undefined;
    var _parsed_searchParams_get1, _Number1;
    const height = (_Number1 = Number((_parsed_searchParams_get1 = parsed.searchParams.get("h")) !== null && _parsed_searchParams_get1 !== void 0 ? _parsed_searchParams_get1 : parsed.searchParams.get("height"))) !== null && _Number1 !== void 0 ? _Number1 : undefined;
    var _parsed_searchParams_get2;
    const quality = Number((_parsed_searchParams_get2 = parsed.searchParams.get("q")) !== null && _parsed_searchParams_get2 !== void 0 ? _parsed_searchParams_get2 : parsed.searchParams.get("quality")) || undefined;
    const format = parsed.searchParams.get("fm") || undefined;
    const base = parsed.searchParams.get("url") || "";
    const params = {
        quality: quality
    };
    parsed.searchParams.forEach((value, key)=>{
        if ($c44ceeb1a0afd531$var$skippedParams.has(key)) return;
        params[key] = value;
    });
    parsed.search = "";
    return {
        base: base,
        width: width,
        height: height,
        format: format,
        params: params,
        cdn: "netlify"
    };
};
const $c44ceeb1a0afd531$export$80d376111cc09ad7 = (_param)=>{
    var { base: base, width: width, height: height, format: format, params: { site: site, quality: quality } = {} } = _param, params = (0, $97429791653469d6$export$69fdd232f62cde60)(_param.params, [
        "site",
        "quality"
    ]);
    const url = (0, $44972171fb249819$export$1758be3e5622c165)("/.netlify/images", site);
    Object.entries(params).forEach(([key, value])=>(0, $44972171fb249819$export$b3ce47f2ef28a28)(url, key, value));
    (0, $44972171fb249819$export$b3ce47f2ef28a28)(url, "q", quality, true, true);
    (0, $44972171fb249819$export$b3ce47f2ef28a28)(url, "w", width, true, true);
    (0, $44972171fb249819$export$b3ce47f2ef28a28)(url, "h", height, true, true);
    (0, $44972171fb249819$export$b3ce47f2ef28a28)(url, "fm", format);
    (0, $44972171fb249819$export$afb2828c24f592c8)(url, "fit", "cover");
    url.searchParams.set("url", base.toString());
    return (0, $44972171fb249819$export$9a5ff27ac96579c6)(url);
};
const $c44ceeb1a0afd531$export$51186ad6e864892a = (options)=>{
    var _options_cdnOptions_netlify, _options_cdnOptions;
    const url = (0, $44972171fb249819$export$1758be3e5622c165)(options.url);
    // If this is a Netlify image URL, we'll manipulate it rather than using it as the source image
    if (url.pathname.startsWith("/.netlify/images")) {
        const { params: params, base: base, format: format } = $c44ceeb1a0afd531$export$98e6a39c04603d36(url);
        return $c44ceeb1a0afd531$export$80d376111cc09ad7((0, $a6ebb6f5eece5690$export$4fa2f4023c9cbda5)((0, $429981144fb29922$export$581ff339ea0ba762)({
            base: base,
            format: format
        }, options), {
            params: (0, $a6ebb6f5eece5690$export$4fa2f4023c9cbda5)((0, $429981144fb29922$export$581ff339ea0ba762)({}, params), {
                // If hostname is "n", we're dealing with a relative URL, so we don't need to set the site param
                site: url.hostname === "n" ? undefined : url.origin
            })
        }));
    }
    return $c44ceeb1a0afd531$export$80d376111cc09ad7((0, $a6ebb6f5eece5690$export$4fa2f4023c9cbda5)((0, $429981144fb29922$export$581ff339ea0ba762)({}, options), {
        base: options.url,
        params: {
            site: (_options_cdnOptions = options.cdnOptions) === null || _options_cdnOptions === void 0 ? void 0 : (_options_cdnOptions_netlify = _options_cdnOptions.netlify) === null || _options_cdnOptions_netlify === void 0 ? void 0 : _options_cdnOptions_netlify.site
        }
    }));
};



const $6662940de247eb45$var$getTransformParams = (url)=>{
    const transforms = url.searchParams.get("tr") || "";
    return transforms.split(",").reduce((acc, transform)=>{
        const [key, value] = transform.split("-");
        acc[key] = value;
        return acc;
    }, {});
};
const $6662940de247eb45$export$51186ad6e864892a = ({ url: originalUrl, width: width, height: height, format: format })=>{
    const url = (0, $44972171fb249819$export$1758be3e5622c165)(originalUrl);
    const transformParams = $6662940de247eb45$var$getTransformParams(url);
    transformParams.w = width ? Math.round(width) : width;
    transformParams.h = height ? Math.round(height) : height;
    if (!transformParams.fm) transformParams.fm = "auto";
    if (format) transformParams.fm = format;
    const tr = Object.keys(transformParams).map((key)=>{
        const value = transformParams[key];
        if (value) return `${key}-${value}`;
    }).filter((x)=>x).join(",");
    url.searchParams.set("tr", tr);
    return url;
};
const $6662940de247eb45$export$98e6a39c04603d36 = (url)=>{
    const parsed = (0, $44972171fb249819$export$1758be3e5622c165)(url);
    const transformParams = $6662940de247eb45$var$getTransformParams(parsed);
    const width = Number(transformParams.w) || undefined;
    const height = Number(transformParams.h) || undefined;
    const format = transformParams.fm || undefined;
    parsed.search = "";
    return {
        base: parsed.toString(),
        width: width,
        height: height,
        format: format,
        params: transformParams,
        cdn: "imagekit"
    };
};





// Image servers that might delegate to another CDN
const $71153f5c8764b46e$var$delegators = {
    vercel: $0423897cdb6b7664$export$eab35c9036dd66d1,
    nextjs: $0423897cdb6b7664$export$eab35c9036dd66d1
};
function $71153f5c8764b46e$export$7c38433b134bffaf(url, cdn) {
    // Most CDNs are authoritative for their own URLs
    if (!(cdn in $71153f5c8764b46e$var$delegators)) return false;
    const maybeDelegate = $71153f5c8764b46e$var$delegators[cdn];
    if (!maybeDelegate) return false;
    return maybeDelegate(url);
}
function $71153f5c8764b46e$export$4e0f0e05e643e578(url, defaultCdn) {
    const cdn = (0, $697dc7106d3c3089$export$e1399f03bc6dd3e5)(url) || defaultCdn;
    if (!cdn) return false;
    const maybeDelegated = $71153f5c8764b46e$export$7c38433b134bffaf(url, cdn);
    if (maybeDelegated) return maybeDelegated;
    return {
        cdn: cdn,
        url: url
    };
}


const $4ab53b02fea068da$export$58e86018bd6095cc = (cdn)=>({
        imgix: $0d8431c0744288d8$export$51186ad6e864892a,
        contentful: $0a7c0d9850e5a54e$export$51186ad6e864892a,
        "builder.io": (0, $f58e2b46bd22cfb6$export$51186ad6e864892a),
        shopify: $b4a6e4273b42d3fe$export$51186ad6e864892a,
        wordpress: $48e377cbc1615ca8$export$51186ad6e864892a,
        cloudimage: $792d1e5bc93e10c8$export$51186ad6e864892a,
        cloudinary: $2572c1614382eadf$export$51186ad6e864892a,
        bunny: $af07e4e9c9a96ab6$export$51186ad6e864892a,
        storyblok: $28152f210342af02$export$51186ad6e864892a,
        cloudflare: $81bd871b8f1f0a0e$export$51186ad6e864892a,
        vercel: $0423897cdb6b7664$export$51186ad6e864892a,
        nextjs: $206aac1cc04ad0bc$export$51186ad6e864892a,
        scene7: $ca8867de4c2828ec$export$51186ad6e864892a,
        "kontent.ai": (0, $a69549a44906e25e$export$51186ad6e864892a),
        keycdn: $e2a2bbf5dab34cd2$export$51186ad6e864892a,
        directus: $e50f1c04065502cf$export$51186ad6e864892a,
        imageengine: $33fe6d6ca9d1fc85$export$51186ad6e864892a,
        contentstack: $5b6d484210859047$export$51186ad6e864892a,
        "cloudflare_images": (0, $cf4f434e1e8859b7$export$51186ad6e864892a),
        ipx: $f0d4015d5362be75$export$51186ad6e864892a,
        astro: $f89c0e79ccb90b21$export$51186ad6e864892a,
        netlify: $c44ceeb1a0afd531$export$51186ad6e864892a,
        imagekit: $6662940de247eb45$export$51186ad6e864892a
    })[cdn];
const $4ab53b02fea068da$export$a8bd7c998575ac50 = (cdn)=>{
    if (!cdn) return undefined;
    return $4ab53b02fea068da$export$58e86018bd6095cc(cdn);
};
const $4ab53b02fea068da$export$f784c93c2c19988 = (options)=>{
    var _getTransformerForCdn, _getTransformer;
    var _options_cdn;
    const cdn = (_options_cdn = options === null || options === void 0 ? void 0 : options.cdn) !== null && _options_cdn !== void 0 ? _options_cdn : (0, $697dc7106d3c3089$export$e1399f03bc6dd3e5)(options.url);
    var _options_recursive;
    // Default to recursive
    if (!((_options_recursive = options.recursive) !== null && _options_recursive !== void 0 ? _options_recursive : true)) return (_getTransformerForCdn = $4ab53b02fea068da$export$a8bd7c998575ac50(cdn)) === null || _getTransformerForCdn === void 0 ? void 0 : _getTransformerForCdn(options);
    const canonical = (0, $71153f5c8764b46e$export$4e0f0e05e643e578)(options.url, cdn);
    if (!canonical || !canonical.cdn) return undefined;
    return (_getTransformer = $4ab53b02fea068da$export$58e86018bd6095cc(canonical.cdn)) === null || _getTransformer === void 0 ? void 0 : _getTransformer((0, $a6ebb6f5eece5690$export$4fa2f4023c9cbda5)((0, $429981144fb29922$export$581ff339ea0ba762)({}, options), {
        url: canonical.url
    }));
};
const $4ab53b02fea068da$export$cd90d5746e19f334 = (url)=>$4ab53b02fea068da$export$a8bd7c998575ac50((0, $697dc7106d3c3089$export$e1399f03bc6dd3e5)(url));



























const $85243d756e1689c7$export$19131010e7fd8373 = {
    imgix: $0d8431c0744288d8$export$98e6a39c04603d36,
    contentful: $0a7c0d9850e5a54e$export$98e6a39c04603d36,
    "builder.io": (0, $f58e2b46bd22cfb6$export$98e6a39c04603d36),
    shopify: $b4a6e4273b42d3fe$export$98e6a39c04603d36,
    wordpress: $48e377cbc1615ca8$export$98e6a39c04603d36,
    cloudimage: $792d1e5bc93e10c8$export$98e6a39c04603d36,
    cloudinary: $2572c1614382eadf$export$98e6a39c04603d36,
    cloudflare: $81bd871b8f1f0a0e$export$98e6a39c04603d36,
    bunny: $af07e4e9c9a96ab6$export$98e6a39c04603d36,
    storyblok: $28152f210342af02$export$98e6a39c04603d36,
    "kontent.ai": (0, $a69549a44906e25e$export$98e6a39c04603d36),
    vercel: $0423897cdb6b7664$export$98e6a39c04603d36,
    nextjs: $206aac1cc04ad0bc$export$98e6a39c04603d36,
    scene7: $ca8867de4c2828ec$export$98e6a39c04603d36,
    keycdn: $e2a2bbf5dab34cd2$export$98e6a39c04603d36,
    directus: $e50f1c04065502cf$export$98e6a39c04603d36,
    imageengine: $33fe6d6ca9d1fc85$export$98e6a39c04603d36,
    contentstack: $5b6d484210859047$export$98e6a39c04603d36,
    "cloudflare_images": (0, $cf4f434e1e8859b7$export$98e6a39c04603d36),
    ipx: $f0d4015d5362be75$export$98e6a39c04603d36,
    astro: $f89c0e79ccb90b21$export$98e6a39c04603d36,
    netlify: $c44ceeb1a0afd531$export$98e6a39c04603d36,
    imagekit: $6662940de247eb45$export$98e6a39c04603d36
};
const $85243d756e1689c7$export$c6a750ef1a24b1d3 = (cdn)=>cdn && cdn in $85243d756e1689c7$export$19131010e7fd8373;
const $85243d756e1689c7$export$6f61912797280af6 = (url)=>$85243d756e1689c7$export$cc93202bdc94062d((0, $697dc7106d3c3089$export$e1399f03bc6dd3e5)(url));
const $85243d756e1689c7$export$cc93202bdc94062d = (cdn)=>{
    if (!cdn || !$85243d756e1689c7$export$c6a750ef1a24b1d3(cdn)) return undefined;
    return $85243d756e1689c7$export$19131010e7fd8373[cdn];
};
const $85243d756e1689c7$export$7a5253c0f62e0150 = (url, cdn)=>{
    var _getParserForCdn, _getParserForCdn1;
    if (cdn) return (_getParserForCdn = $85243d756e1689c7$export$cc93202bdc94062d(cdn)) === null || _getParserForCdn === void 0 ? void 0 : _getParserForCdn(url);
    const detectedCdn = (0, $697dc7106d3c3089$export$e1399f03bc6dd3e5)(url);
    if (!detectedCdn) return undefined;
    if (!$85243d756e1689c7$export$c6a750ef1a24b1d3(detectedCdn)) return {
        cdn: detectedCdn,
        base: url.toString()
    };
    return (_getParserForCdn1 = $85243d756e1689c7$export$cc93202bdc94062d(detectedCdn)) === null || _getParserForCdn1 === void 0 ? void 0 : _getParserForCdn1(url);
};





var $c69cc303f69684d2$import_meta = Object.assign(Object.create(null), {
    url: "file:///packages/core/dist/core.mjs"
});
var $c69cc303f69684d2$var$_env;
// src/mediaquery.ts
var $c69cc303f69684d2$var$RE_MEDIA_QUERY = /^(?:(only|not)?\s*([_a-z][_a-z0-9-]*)|(\([^)]+\)))(?:\s*and\s*(.*))?$/i;
var $c69cc303f69684d2$var$RE_MQ_EXPRESSION = /^\(\s*([_a-z-][_a-z0-9-]*)\s*(?::\s*([^)]+))?\s*\)$/;
var $c69cc303f69684d2$var$RE_MQ_FEATURE = /^(?:(min|max)-)?(.+)/;
function $c69cc303f69684d2$var$parse(mediaQuery) {
    return mediaQuery.split(",").map(function(query) {
        query = query.trim();
        const captures = query.match($c69cc303f69684d2$var$RE_MEDIA_QUERY);
        if (!captures) throw new SyntaxError('Invalid CSS media query: "' + query + '"');
        const modifier = captures[1];
        const type = captures[2];
        const parsed = {
            inverse: !!modifier && modifier.toLowerCase() === "not",
            type: type ? type.toLowerCase() : "all",
            expressions: []
        };
        const expressions = ((captures[3] || "") + (captures[4] || "")).trim();
        if (!expressions) return parsed;
        const expressionList = expressions.match(/\([^)]+\)/g);
        if (!expressionList) throw new SyntaxError('Invalid CSS media query: "' + query + '"');
        parsed.expressions = expressionList.map(function(expression) {
            const captures2 = expression.match($c69cc303f69684d2$var$RE_MQ_EXPRESSION);
            if (!captures2) throw new SyntaxError('Invalid CSS media query: "' + query + '"');
            const feature = captures2[1].toLowerCase().match($c69cc303f69684d2$var$RE_MQ_FEATURE);
            var _feature_, _feature_1;
            return {
                modifier: (_feature_ = feature === null || feature === void 0 ? void 0 : feature[1]) !== null && _feature_ !== void 0 ? _feature_ : "",
                feature: (_feature_1 = feature === null || feature === void 0 ? void 0 : feature[2]) !== null && _feature_1 !== void 0 ? _feature_1 : "",
                value: captures2[2]
            };
        });
        return parsed;
    });
}
// src/core.ts
var $c69cc303f69684d2$var$DEBUG = ($c69cc303f69684d2$var$_env = $c69cc303f69684d2$import_meta.env) === null || $c69cc303f69684d2$var$_env === void 0 ? void 0 : $c69cc303f69684d2$var$_env.DEV;
function $c69cc303f69684d2$export$58da9968c3170cb1(...args) {
    if ($c69cc303f69684d2$var$DEBUG) console.error("[unpic]", ...args);
}
var $c69cc303f69684d2$export$61fb8b9b71aca0dd = (width, layout)=>{
    if (!width || !layout) return void 0;
    switch(layout){
        case `constrained`:
            return `(min-width: ${width}px) ${width}px, 100vw`;
        case `fixed`:
            return `${width}px`;
        case `fullWidth`:
            return `100vw`;
        default:
            return void 0;
    }
};
var $c69cc303f69684d2$var$pixelate = (value)=>value || value === 0 ? `${value}px` : void 0;
var $c69cc303f69684d2$export$3d2f074408bd1b82 = ({ width: width, height: height, aspectRatio: aspectRatio, layout: layout, objectFit: objectFit = "cover", background: background })=>{
    const styleEntries = [
        [
            "object-fit",
            objectFit
        ]
    ];
    if ((background === null || background === void 0 ? void 0 : background.startsWith("https:")) || (background === null || background === void 0 ? void 0 : background.startsWith("http:")) || (background === null || background === void 0 ? void 0 : background.startsWith("data:"))) {
        styleEntries.push([
            "background-image",
            `url(${background})`
        ]);
        styleEntries.push([
            "background-size",
            "cover"
        ]);
        styleEntries.push([
            "background-repeat",
            "no-repeat"
        ]);
    } else styleEntries.push([
        "background",
        background
    ]);
    if (layout === "fixed") {
        styleEntries.push([
            "width",
            $c69cc303f69684d2$var$pixelate(width)
        ]);
        styleEntries.push([
            "height",
            $c69cc303f69684d2$var$pixelate(height)
        ]);
    }
    if (layout === "constrained") {
        styleEntries.push([
            "max-width",
            $c69cc303f69684d2$var$pixelate(width)
        ]);
        styleEntries.push([
            "max-height",
            $c69cc303f69684d2$var$pixelate(height)
        ]);
        styleEntries.push([
            "aspect-ratio",
            aspectRatio ? `${aspectRatio}` : void 0
        ]);
        styleEntries.push([
            "width",
            "100%"
        ]);
    }
    if (layout === "fullWidth") {
        styleEntries.push([
            "width",
            "100%"
        ]);
        styleEntries.push([
            "aspect-ratio",
            aspectRatio ? `${aspectRatio}` : void 0
        ]);
        styleEntries.push([
            "height",
            $c69cc303f69684d2$var$pixelate(height)
        ]);
    }
    return Object.fromEntries(styleEntries.filter(([, value])=>value));
};
var $c69cc303f69684d2$export$809fcacd48efe925 = [
    6016,
    // 6K
    5120,
    // 5K
    4480,
    // 4.5K
    3840,
    // 4K
    3200,
    // QHD+
    2560,
    // WQXGA
    2048,
    // QXGA
    1920,
    // 1080p
    1668,
    // Various iPads
    1280,
    // 720p
    1080,
    // iPhone 6-8 Plus
    960,
    // older horizontal phones
    828,
    // iPhone XR/11
    750,
    // iPhone 6-8
    640
];
var $c69cc303f69684d2$var$LOW_RES_WIDTH = 24;
var $c69cc303f69684d2$export$a3d0667c85e012da = ({ width: width, layout: layout, resolutions: resolutions = $c69cc303f69684d2$export$809fcacd48efe925 })=>{
    if (layout === "fullWidth") return resolutions;
    if (!width) return [];
    const doubleWidth = width * 2;
    if (layout === "fixed") return [
        width,
        doubleWidth
    ];
    if (layout === "constrained") return [
        // Always include the image at 1x and 2x the specified width
        width,
        doubleWidth,
        // Filter out any resolutions that are larger than the double-res image
        ...resolutions.filter((w)=>w < doubleWidth)
    ];
    return [];
};
var $c69cc303f69684d2$export$624d8741631cccad = ({ src: src, width: width, layout: layout = "constrained", height: height, aspectRatio: aspectRatio, breakpoints: breakpoints, cdn: cdn, transformer: transformer, format: format })=>{
    const canonical = (0, $71153f5c8764b46e$export$4e0f0e05e643e578)(src, cdn);
    if (canonical && !transformer) transformer = (0, $4ab53b02fea068da$export$58e86018bd6095cc)(canonical.cdn);
    if (!transformer) return [];
    breakpoints || (breakpoints = $c69cc303f69684d2$export$a3d0667c85e012da({
        width: width,
        layout: layout
    }));
    return breakpoints.sort((a, b)=>a - b).map((bp)=>{
        let transformedHeight;
        if (height && aspectRatio) transformedHeight = Math.round(bp / aspectRatio);
        return {
            url: canonical ? canonical.url : src,
            width: bp,
            height: transformedHeight,
            format: format
        };
    });
};
var $c69cc303f69684d2$export$7ab3f8b89543d628 = (options)=>{
    let { src: src, cdn: cdn, transformer: transformer } = options;
    const canonical = (0, $71153f5c8764b46e$export$4e0f0e05e643e578)(src, cdn);
    if (canonical && !transformer) transformer = (0, $4ab53b02fea068da$export$58e86018bd6095cc)(canonical.cdn);
    if (!transformer) return "";
    return $c69cc303f69684d2$export$624d8741631cccad((0, $a6ebb6f5eece5690$export$4fa2f4023c9cbda5)((0, $429981144fb29922$export$581ff339ea0ba762)({}, options), {
        transformer: transformer
    })).map((transform)=>{
        const url = transformer(transform);
        return `${url === null || url === void 0 ? void 0 : url.toString()} ${transform.width}w`;
    }).join(",\n");
};
function $c69cc303f69684d2$export$5422901424cda970(_param) {
    var { width: width, height: height, priority: priority, layout: layout = "constrained", aspectRatio: aspectRatio } = _param, props = (0, $97429791653469d6$export$69fdd232f62cde60)(_param, [
        "width",
        "height",
        "priority",
        "layout",
        "aspectRatio"
    ]);
    var _props;
    width = width && Number(width) || void 0;
    height = height && Number(height) || void 0;
    if (priority) {
        var _props1, _props2;
        (_props1 = props).loading || (_props1.loading = "eager");
        (_props2 = props).fetchpriority || (_props2.fetchpriority = "high");
    } else {
        var _props3, _props4;
        (_props3 = props).loading || (_props3.loading = "lazy");
        (_props4 = props).decoding || (_props4.decoding = "async");
    }
    if (props.alt === "") (_props = props).role || (_props.role = "presentation");
    if (aspectRatio) {
        if (width) {
            if (height) $c69cc303f69684d2$export$58da9968c3170cb1("Ignoring aspectRatio because width and height are both set");
            else height = width / aspectRatio;
        } else if (height) width = height * aspectRatio;
        else if (layout !== "fullWidth") $c69cc303f69684d2$export$58da9968c3170cb1("When aspectRatio is set, either width or height must also be set");
    } else if (width && height) aspectRatio = width / height;
    else if (layout !== "fullWidth") $c69cc303f69684d2$export$58da9968c3170cb1("Either aspectRatio or both width and height must be set");
    return (0, $429981144fb29922$export$581ff339ea0ba762)({
        width: width,
        height: height,
        aspectRatio: aspectRatio,
        layout: layout
    }, props);
}
function $c69cc303f69684d2$export$7b42a0094fb00b6e(props) {
    var _transformedProps;
    let _transformSharedProps = $c69cc303f69684d2$export$5422901424cda970(props), { src: src, cdn: cdn, transformer: transformer, background: background, layout: layout, objectFit: objectFit, breakpoints: breakpoints, width: width, height: height, aspectRatio: aspectRatio, unstyled: unstyled } = _transformSharedProps, transformedProps = (0, $97429791653469d6$export$69fdd232f62cde60)(_transformSharedProps, [
        "src",
        "cdn",
        "transformer",
        "background",
        "layout",
        "objectFit",
        "breakpoints",
        "width",
        "height",
        "aspectRatio",
        "unstyled"
    ]);
    const canonical = src ? (0, $71153f5c8764b46e$export$4e0f0e05e643e578)(src, cdn) : void 0;
    let url = src;
    if (canonical) {
        url = canonical.url;
        transformer || (transformer = (0, $4ab53b02fea068da$export$58e86018bd6095cc)(canonical.cdn));
    }
    if (transformer && background === "auto") {
        const lowResHeight = aspectRatio ? Math.round($c69cc303f69684d2$var$LOW_RES_WIDTH / aspectRatio) : void 0;
        const lowResImage = transformer({
            url: url,
            width: $c69cc303f69684d2$var$LOW_RES_WIDTH,
            height: lowResHeight
        });
        if (lowResImage) background = lowResImage.toString();
    }
    const styleProps = {
        width: width,
        height: height,
        aspectRatio: aspectRatio,
        layout: layout,
        objectFit: objectFit,
        background: background
    };
    (_transformedProps = transformedProps).sizes || (_transformedProps.sizes = $c69cc303f69684d2$export$61fb8b9b71aca0dd(width, layout));
    if (!unstyled) transformedProps.style = (0, $429981144fb29922$export$581ff339ea0ba762)({}, $c69cc303f69684d2$export$3d2f074408bd1b82(styleProps), transformedProps.style);
    if (transformer) {
        transformedProps.srcset = $c69cc303f69684d2$export$7ab3f8b89543d628({
            src: url,
            width: width,
            height: height,
            aspectRatio: aspectRatio,
            layout: layout,
            breakpoints: breakpoints,
            transformer: transformer,
            cdn: cdn
        });
        const transformed = transformer({
            url: url,
            width: width,
            height: height
        });
        if (transformed) url = transformed;
        if (layout === "fullWidth" || layout === "constrained") {
            width = void 0;
            height = void 0;
        }
    }
    if (!url) $c69cc303f69684d2$export$58da9968c3170cb1("No URL provided for image");
    return (0, $a6ebb6f5eece5690$export$4fa2f4023c9cbda5)((0, $429981144fb29922$export$581ff339ea0ba762)({}, transformedProps), {
        src: url === null || url === void 0 ? void 0 : url.toString(),
        width: width,
        height: height
    });
}
function $c69cc303f69684d2$export$366ac764d1177fbf(type) {
    if (!type) return {};
    if (type.startsWith("image/")) return {
        format: type.slice(6),
        mimeType: type
    };
    return {
        format: type,
        mimeType: `image/${type === "jpg" ? "jpeg" : type}`
    };
}
function $c69cc303f69684d2$export$d2120fbadb6f992c(_param) {
    var { media: media, type: type } = _param, props = (0, $97429791653469d6$export$69fdd232f62cde60)(_param, [
        "media",
        "type"
    ]);
    let _transformSharedProps = $c69cc303f69684d2$export$5422901424cda970(props), { src: src, cdn: cdn, transformer: transformer, layout: layout, breakpoints: breakpoints, width: width, height: height, aspectRatio: aspectRatio, sizes: sizes, loading: loading, decoding: decoding } = _transformSharedProps, rest = (0, $97429791653469d6$export$69fdd232f62cde60)(_transformSharedProps, [
        "src",
        "cdn",
        "transformer",
        "layout",
        "breakpoints",
        "width",
        "height",
        "aspectRatio",
        "sizes",
        "loading",
        "decoding"
    ]);
    const canonical = src ? (0, $71153f5c8764b46e$export$4e0f0e05e643e578)(src, cdn) : void 0;
    let url = src;
    if (canonical) {
        url = canonical.url;
        transformer || (transformer = (0, $4ab53b02fea068da$export$58e86018bd6095cc)(canonical.cdn));
    }
    if (!transformer) return {};
    const { format: format, mimeType: mimeType } = $c69cc303f69684d2$export$366ac764d1177fbf(type);
    sizes || (sizes = $c69cc303f69684d2$export$61fb8b9b71aca0dd(width, layout));
    const srcset = $c69cc303f69684d2$export$7ab3f8b89543d628({
        src: url,
        width: width,
        height: height,
        aspectRatio: aspectRatio,
        layout: layout,
        breakpoints: breakpoints,
        transformer: transformer,
        cdn: cdn,
        format: format
    });
    const transformed = transformer({
        url: url,
        width: width,
        height: height
    });
    if (transformed) url = transformed;
    const returnObject = (0, $a6ebb6f5eece5690$export$4fa2f4023c9cbda5)((0, $429981144fb29922$export$581ff339ea0ba762)({}, rest), {
        sizes: sizes,
        srcset: srcset
    });
    if (media) {
        if ($c69cc303f69684d2$var$DEBUG) try {
            $c69cc303f69684d2$var$parse(media);
            returnObject.media = media;
        } catch (e) {
            $c69cc303f69684d2$export$58da9968c3170cb1(e.message);
        }
        else returnObject.media = media;
    }
    if (mimeType) returnObject.type = mimeType;
    return returnObject;
}
function $c69cc303f69684d2$export$cec66202d70b841d(props, imageData) {
    const aspectRatio = props.aspectRatio || imageData.width / imageData.height;
    let { width: width, height: height } = props;
    if (!width) {
        if (height) width = height * aspectRatio;
        else width = imageData.width;
    }
    if (!height) {
        if (width) height = width / aspectRatio;
        else height = imageData.height;
    }
    return {
        width: width,
        height: height
    };
}


var $e0f4562c2102e32f$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $e0f4562c2102e32f$export$282ba8c2f6b7fbe5 = class UnpicImg extends (0, $e6b2ca66b51a68a3$export$3f2f9f5909897157) {
    render() {
        var _a;
        const inputProps = {
            src: this.src,
            width: this.width,
            height: this.height,
            alt: this.alt,
            loading: this.loading,
            decoding: this.decoding,
            role: this.role,
            sizes: this.sizes,
            fetchpriority: this.fetchpriority,
            layout: this.layout
        };
        const transformedProps = (0, $c69cc303f69684d2$export$7b42a0094fb00b6e)(inputProps);
        return (0, $594a69b07daf0e84$export$c0bb0b647f701bb5)`
      <img
        part="image"
        src="${transformedProps.src}"
        alt="${transformedProps.alt}"
        width="${transformedProps.width}"
        height="${transformedProps.height}"
        style="${(0, $a5c28c9fe8362843$export$1e5b4ce2fa884e6a)((_a = transformedProps.style) !== null && _a !== void 0 ? _a : {})}"
        srcset="${transformedProps.srcset}"
        role="${(0, $5df1285dd8b8b456$export$f68dd208b5df064d)(transformedProps.role)}"
        sizes="${transformedProps.sizes}"
        loading="${transformedProps.loading}"
        fetchpriority="${(0, $5df1285dd8b8b456$export$f68dd208b5df064d)(transformedProps.fetchpriority)}"
        decoding="${(0, $5df1285dd8b8b456$export$f68dd208b5df064d)(transformedProps.decoding)}"
        crossorigin="${(0, $5df1285dd8b8b456$export$f68dd208b5df064d)(this.crossOrigin)}"
        ismap="${(0, $5df1285dd8b8b456$export$f68dd208b5df064d)(this.isMap)}"
        name="${(0, $5df1285dd8b8b456$export$f68dd208b5df064d)(this.name)}"
        referrerpolicy="${(0, $5df1285dd8b8b456$export$f68dd208b5df064d)(this.referrerPolicy)}"
        usemap="${(0, $5df1285dd8b8b456$export$f68dd208b5df064d)(this.useMap)}"
        @error="${(event)=>this.dispatchEvent(new ErrorEvent(event.type, event))}"
        @load="${(event)=>this.dispatchEvent(new Event(event.type, event))}"
        @abort="${(event)=>this.dispatchEvent(new Event(event.type, event))}"
      />
    `;
    }
    constructor(){
        super(...arguments);
        this.src = "";
        this.alt = "";
    }
};
$e0f4562c2102e32f$var$__decorate([
    (0, $716e449a79333d97$export$d541bacb2bda4494)({
        type: String
    })
], $e0f4562c2102e32f$export$282ba8c2f6b7fbe5.prototype, "src", void 0);
$e0f4562c2102e32f$var$__decorate([
    (0, $716e449a79333d97$export$d541bacb2bda4494)({
        type: String
    })
], $e0f4562c2102e32f$export$282ba8c2f6b7fbe5.prototype, "alt", void 0);
$e0f4562c2102e32f$var$__decorate([
    (0, $716e449a79333d97$export$d541bacb2bda4494)({
        type: Number
    })
], $e0f4562c2102e32f$export$282ba8c2f6b7fbe5.prototype, "height", void 0);
$e0f4562c2102e32f$var$__decorate([
    (0, $716e449a79333d97$export$d541bacb2bda4494)({
        type: Number
    })
], $e0f4562c2102e32f$export$282ba8c2f6b7fbe5.prototype, "width", void 0);
$e0f4562c2102e32f$var$__decorate([
    (0, $716e449a79333d97$export$d541bacb2bda4494)({
        type: Boolean
    })
], $e0f4562c2102e32f$export$282ba8c2f6b7fbe5.prototype, "priority", void 0);
$e0f4562c2102e32f$var$__decorate([
    (0, $716e449a79333d97$export$d541bacb2bda4494)({
        type: String
    })
], $e0f4562c2102e32f$export$282ba8c2f6b7fbe5.prototype, "fetchpriority", void 0);
$e0f4562c2102e32f$var$__decorate([
    (0, $716e449a79333d97$export$d541bacb2bda4494)({
        type: String
    })
], $e0f4562c2102e32f$export$282ba8c2f6b7fbe5.prototype, "loading", void 0);
$e0f4562c2102e32f$var$__decorate([
    (0, $716e449a79333d97$export$d541bacb2bda4494)({
        type: String
    })
], $e0f4562c2102e32f$export$282ba8c2f6b7fbe5.prototype, "decoding", void 0);
$e0f4562c2102e32f$var$__decorate([
    (0, $716e449a79333d97$export$d541bacb2bda4494)({
        type: String
    })
], $e0f4562c2102e32f$export$282ba8c2f6b7fbe5.prototype, "background", void 0);
$e0f4562c2102e32f$var$__decorate([
    (0, $716e449a79333d97$export$d541bacb2bda4494)({
        type: String
    })
], $e0f4562c2102e32f$export$282ba8c2f6b7fbe5.prototype, "objectFit", void 0);
$e0f4562c2102e32f$var$__decorate([
    (0, $716e449a79333d97$export$d541bacb2bda4494)({
        type: Number
    })
], $e0f4562c2102e32f$export$282ba8c2f6b7fbe5.prototype, "aspectRatio", void 0);
$e0f4562c2102e32f$var$__decorate([
    (0, $716e449a79333d97$export$d541bacb2bda4494)({
        type: String
    })
], $e0f4562c2102e32f$export$282ba8c2f6b7fbe5.prototype, "layout", void 0);
$e0f4562c2102e32f$var$__decorate([
    (0, $716e449a79333d97$export$d541bacb2bda4494)({
        type: Array
    })
], $e0f4562c2102e32f$export$282ba8c2f6b7fbe5.prototype, "breakpoints", void 0);
$e0f4562c2102e32f$var$__decorate([
    (0, $716e449a79333d97$export$d541bacb2bda4494)({
        type: String
    })
], $e0f4562c2102e32f$export$282ba8c2f6b7fbe5.prototype, "cdn", void 0);
$e0f4562c2102e32f$var$__decorate([
    (0, $716e449a79333d97$export$d541bacb2bda4494)({
        type: String
    })
], $e0f4562c2102e32f$export$282ba8c2f6b7fbe5.prototype, "crossOrigin", void 0);
$e0f4562c2102e32f$var$__decorate([
    (0, $716e449a79333d97$export$d541bacb2bda4494)({
        type: Boolean
    })
], $e0f4562c2102e32f$export$282ba8c2f6b7fbe5.prototype, "isMap", void 0);
$e0f4562c2102e32f$var$__decorate([
    (0, $716e449a79333d97$export$d541bacb2bda4494)({
        type: String
    })
], $e0f4562c2102e32f$export$282ba8c2f6b7fbe5.prototype, "name", void 0);
$e0f4562c2102e32f$var$__decorate([
    (0, $716e449a79333d97$export$d541bacb2bda4494)({
        type: String
    })
], $e0f4562c2102e32f$export$282ba8c2f6b7fbe5.prototype, "referrerPolicy", void 0);
$e0f4562c2102e32f$var$__decorate([
    (0, $716e449a79333d97$export$d541bacb2bda4494)({
        type: String
    })
], $e0f4562c2102e32f$export$282ba8c2f6b7fbe5.prototype, "sizes", void 0);
$e0f4562c2102e32f$var$__decorate([
    (0, $716e449a79333d97$export$d541bacb2bda4494)({
        type: String
    })
], $e0f4562c2102e32f$export$282ba8c2f6b7fbe5.prototype, "useMap", void 0);
$e0f4562c2102e32f$export$282ba8c2f6b7fbe5 = $e0f4562c2102e32f$var$__decorate([
    (0, $8b53573f9e3092a2$export$da64fc29f17f9d0e)("unpic-img")
], $e0f4562c2102e32f$export$282ba8c2f6b7fbe5);



})();
//# sourceMappingURL=index.79738b59.js.map
